var items = {
  "block.minecraft.acacia_button": "Buton akacisës",
  "block.minecraft.acacia_door": "Derë akacisës",
  "block.minecraft.acacia_fence": "Gardh akacisës",
  "block.minecraft.acacia_fence_gate": "Portë akacisës",
  "block.minecraft.acacia_hanging_sign": "Tabelë akacisës e varur",
  "block.minecraft.acacia_leaves": "Gjethe akacisës",
  "block.minecraft.acacia_log": "Dru akacisës",
  "block.minecraft.acacia_planks": "Dërrasa akacisës",
  "block.minecraft.acacia_pressure_plate": "Pllakë presioni akacisës",
  "block.minecraft.acacia_sapling": "Fidan akacisës",
  "block.minecraft.acacia_shelf": "Raft akacisës",
  "block.minecraft.acacia_sign": "Tabelë akacisës",
  "block.minecraft.acacia_slab": "Rrasë akacisës",
  "block.minecraft.acacia_stairs": "Shkallë akacisës",
  "block.minecraft.acacia_trapdoor": "Kapanxhë akacisës",
  "block.minecraft.acacia_wall_hanging_sign": "Tabelë akacisës e varur në mur",
  "block.minecraft.acacia_wall_sign": "Tabelë akacisës në mur",
  "block.minecraft.acacia_wood": "Trung akacisës",
  "block.minecraft.activator_rail": "Shina shkrehëse",
  "block.minecraft.air": "Ajër",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bllok ametisti",
  "block.minecraft.amethyst_cluster": "Grumbull ametisti",
  "block.minecraft.ancient_debris": "Mbetje antike",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Rrasë andeziti",
  "block.minecraft.andesite_stairs": "Shkallë andeziti",
  "block.minecraft.andesite_wall": "Mur andeziti",
  "block.minecraft.anvil": "Kudhër",
  "block.minecraft.attached_melon_stem": "Kërcell i shalqirit i ngjitur",
  "block.minecraft.attached_pumpkin_stem": "Kërcell i kungullit i ngjitur",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Gjethe azales",
  "block.minecraft.azure_bluet": "Hjustoni blu",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bllok bambuje",
  "block.minecraft.bamboo_button": "Buton bambuje",
  "block.minecraft.bamboo_door": "Derë bambuje",
  "block.minecraft.bamboo_fence": "Gardh bambuje",
  "block.minecraft.bamboo_fence_gate": "Portë bambuje",
  "block.minecraft.bamboo_hanging_sign": "Tabelë bambuje e varur",
  "block.minecraft.bamboo_mosaic": "Mozaik bambuje",
  "block.minecraft.bamboo_mosaic_slab": "Rrasë mozaiku bambuje",
  "block.minecraft.bamboo_mosaic_stairs": "Shkallë mozaiku bambuje",
  "block.minecraft.bamboo_planks": "Dërrasa bambuje",
  "block.minecraft.bamboo_pressure_plate": "Pllakë presioni bambuje",
  "block.minecraft.bamboo_sapling": "Fidan bambuje",
  "block.minecraft.bamboo_shelf": "Raft bambuje",
  "block.minecraft.bamboo_sign": "Tabelë bambuje",
  "block.minecraft.bamboo_slab": "Rrasë bambuje",
  "block.minecraft.bamboo_stairs": "Shkallë bambuje",
  "block.minecraft.bamboo_trapdoor": "Kapanxhë bambuje",
  "block.minecraft.bamboo_wall_hanging_sign": "Tabelë bambuje e varur në mur",
  "block.minecraft.bamboo_wall_sign": "Tabelë bambuje në mur",
  "block.minecraft.banner.base.black": "Fushë plotësisht e zezë",
  "block.minecraft.banner.base.blue": "Fushë plotësisht blu",
  "block.minecraft.banner.base.brown": "Fushë plotësisht e kaftë",
  "block.minecraft.banner.base.cyan": "Fushë plotësisht cian",
  "block.minecraft.banner.base.gray": "Fushë plotësisht gri",
  "block.minecraft.banner.base.green": "Fushë plotësisht e gjelbër",
  "block.minecraft.banner.base.light_blue": "Fushë plotësisht blu e lehtë",
  "block.minecraft.banner.base.light_gray": "Fushë plotësisht gri e lehtë",
  "block.minecraft.banner.base.lime": "Fushë plotësisht e gjelbër e çelët",
  "block.minecraft.banner.base.magenta": "Fushë plotësisht e purpurtë",
  "block.minecraft.banner.base.orange": "Fushë plotësisht portokalli",
  "block.minecraft.banner.base.pink": "Fushë plotësisht rozë",
  "block.minecraft.banner.base.purple": "Fushë plotësisht vjollcë",
  "block.minecraft.banner.base.red": "Fushë plotësisht e kuqe",
  "block.minecraft.banner.base.white": "Fushë plotësisht e bardhë",
  "block.minecraft.banner.base.yellow": "Fushë plotësisht e verdhë",
  "block.minecraft.banner.border.black": "Kufiri i zi",
  "block.minecraft.banner.border.blue": "Kufiri blu",
  "block.minecraft.banner.border.brown": "Kufiri i kaftë",
  "block.minecraft.banner.border.cyan": "Kufiri cian",
  "block.minecraft.banner.border.gray": "Kufiri gri",
  "block.minecraft.banner.border.green": "Kufiri i gjelbër",
  "block.minecraft.banner.border.light_blue": "Kufiri blu e lehtë",
  "block.minecraft.banner.border.light_gray": "Kufiri gri e lehtë",
  "block.minecraft.banner.border.lime": "Kufiri i gjelbër e çelët",
  "block.minecraft.banner.border.magenta": "Kufiri i purpurtë",
  "block.minecraft.banner.border.orange": "Kufiri portokalli",
  "block.minecraft.banner.border.pink": "Kufiri rozë",
  "block.minecraft.banner.border.purple": "Kufiri vjollcë",
  "block.minecraft.banner.border.red": "Kufiri i kuq",
  "block.minecraft.banner.border.white": "Kufiri i bardhë",
  "block.minecraft.banner.border.yellow": "Kufiri i verdhë",
  "block.minecraft.banner.bricks.black": "Fushë me tulla të zeza",
  "block.minecraft.banner.bricks.blue": "Fushë me tulla blu",
  "block.minecraft.banner.bricks.brown": "Fushë me tulla të kafta",
  "block.minecraft.banner.bricks.cyan": "Fushë me tulla cian",
  "block.minecraft.banner.bricks.gray": "Fushë me tulla gri",
  "block.minecraft.banner.bricks.green": "Fushë me tulla të gjelbërta",
  "block.minecraft.banner.bricks.light_blue": "Fushë me tulla blu e lehtë",
  "block.minecraft.banner.bricks.light_gray": "Fushë me tulla gri e lehtë",
  "block.minecraft.banner.bricks.lime": "Fushë me tulla të gjelbërta të çelët",
  "block.minecraft.banner.bricks.magenta": "Fushë me tulla të purpurtë",
  "block.minecraft.banner.bricks.orange": "Fushë me tulla portokalli",
  "block.minecraft.banner.bricks.pink": "Fushë me tulla rozë",
  "block.minecraft.banner.bricks.purple": "Fushë me tulla vjollcë",
  "block.minecraft.banner.bricks.red": "Fushë me tulla të kuqe",
  "block.minecraft.banner.bricks.white": "Fushë me tulla të bardha",
  "block.minecraft.banner.bricks.yellow": "Fushë me tulla të verdha",
  "block.minecraft.banner.circle.black": "Rreth i zi",
  "block.minecraft.banner.circle.blue": "Rrethi blu",
  "block.minecraft.banner.circle.brown": "Rreth i kaftë",
  "block.minecraft.banner.circle.cyan": "Rrethi cian",
  "block.minecraft.banner.circle.gray": "Rrethi gri",
  "block.minecraft.banner.circle.green": "Rreth i gjelbër",
  "block.minecraft.banner.circle.light_blue": "Rrethi blu e lehtë",
  "block.minecraft.banner.circle.light_gray": "Rrethi gri e lehtë",
  "block.minecraft.banner.circle.lime": "Rreth i gjelbër e çelët",
  "block.minecraft.banner.circle.magenta": "Rreth i purpurtë",
  "block.minecraft.banner.circle.orange": "Rrethi portokalli",
  "block.minecraft.banner.circle.pink": "Rrethi rozë",
  "block.minecraft.banner.circle.purple": "Rrethi vjollcë",
  "block.minecraft.banner.circle.red": "Rreth i kuq",
  "block.minecraft.banner.circle.white": "Rreth i bardhë",
  "block.minecraft.banner.circle.yellow": "Rreth i verdhë",
  "block.minecraft.banner.creeper.black": "Fytyra e Creeper-it të zi",
  "block.minecraft.banner.creeper.blue": "Fytyra e Creeper-it blu",
  "block.minecraft.banner.creeper.brown": "Fytyra e Creeper-it e kaftë",
  "block.minecraft.banner.creeper.cyan": "Fytyra e Creeper-it cian",
  "block.minecraft.banner.creeper.gray": "Fytyra e Creeper-it gri",
  "block.minecraft.banner.creeper.green": "Fytyra e Creeper-it së gjelbër",
  "block.minecraft.banner.creeper.light_blue": "Fytyra e Creeper-it blu e lehtë",
  "block.minecraft.banner.creeper.light_gray": "Fytyra e Creeper-it gri e lehtë",
  "block.minecraft.banner.creeper.lime": "Fytyra e Creeper-it gjelbër e çelët",
  "block.minecraft.banner.creeper.magenta": "Fytyra e Creeper-it purpurtë",
  "block.minecraft.banner.creeper.orange": "Fytyra e Creeper-it portokalli",
  "block.minecraft.banner.creeper.pink": "Fytyra e Creeper-it rozë",
  "block.minecraft.banner.creeper.purple": "Fytyra e Creeper-it vjollcë",
  "block.minecraft.banner.creeper.red": "Fytyra e Creeper-it i kuq",
  "block.minecraft.banner.creeper.white": "Fytyra e Creeper-it të bardhë",
  "block.minecraft.banner.creeper.yellow": "Fytyra e Creeper-it i verdhë",
  "block.minecraft.banner.cross.black": "Kryq i zi",
  "block.minecraft.banner.cross.blue": "Kryq blu",
  "block.minecraft.banner.cross.brown": "Kryq i kaftë",
  "block.minecraft.banner.cross.cyan": "Kryq cian",
  "block.minecraft.banner.cross.gray": "Kryq gri",
  "block.minecraft.banner.cross.green": "Kryq i gjelbër",
  "block.minecraft.banner.cross.light_blue": "Kryq blu e lehtë",
  "block.minecraft.banner.cross.light_gray": "Kryq gri e lehtë",
  "block.minecraft.banner.cross.lime": "Kryq i gjelbër e çelët",
  "block.minecraft.banner.cross.magenta": "Kryq i purpurtë",
  "block.minecraft.banner.cross.orange": "Kryq portokalli",
  "block.minecraft.banner.cross.pink": "Kryq rozë",
  "block.minecraft.banner.cross.purple": "Kryq vjollcë",
  "block.minecraft.banner.cross.red": "Kryq i kuq",
  "block.minecraft.banner.cross.white": "Kryq i bardhë",
  "block.minecraft.banner.cross.yellow": "Kryq i verdhë",
  "block.minecraft.banner.curly_border.black": "Kufiri i zi me kaçurrela",
  "block.minecraft.banner.curly_border.blue": "Kufiri blu me kaçurrela",
  "block.minecraft.banner.curly_border.brown": "Kufiri i kaftë me kaçurrela",
  "block.minecraft.banner.curly_border.cyan": "Kufiri cian me kaçurrela",
  "block.minecraft.banner.curly_border.gray": "Kufiri gri me kaçurrela",
  "block.minecraft.banner.curly_border.green": "Kufiri i gjelbër me kaçurrela",
  "block.minecraft.banner.curly_border.light_blue": "Kufiri blu e lehtë me kaçurrela",
  "block.minecraft.banner.curly_border.light_gray": "Kufiri gri e lehtë me kaçurrela",
  "block.minecraft.banner.curly_border.lime": "Kufiri i gjelbër e çelët me kaçurrela",
  "block.minecraft.banner.curly_border.magenta": "Kufiri i purpurtë me kaçurrela",
  "block.minecraft.banner.curly_border.orange": "Kufiri portokalli me kaçurrela",
  "block.minecraft.banner.curly_border.pink": "Kufiri rozë me kaçurrela",
  "block.minecraft.banner.curly_border.purple": "Kufiri vjollcë me kaçurrela",
  "block.minecraft.banner.curly_border.red": "Kufiri i kuq me kaçurrela",
  "block.minecraft.banner.curly_border.white": "Kufiri i bardhë me kaçurrela",
  "block.minecraft.banner.curly_border.yellow": "Kufiri i verdhë me kaçurrela",
  "block.minecraft.banner.diagonal_left.black": "Diagonale e zezë majtas",
  "block.minecraft.banner.diagonal_left.blue": "Diagonale blu majtas",
  "block.minecraft.banner.diagonal_left.brown": "Diagonale e kaftë majtas",
  "block.minecraft.banner.diagonal_left.cyan": "Diagonale cian majtas",
  "block.minecraft.banner.diagonal_left.gray": "Diagonale gri majtas",
  "block.minecraft.banner.diagonal_left.green": "Diagonale e gjelbër majtas",
  "block.minecraft.banner.diagonal_left.light_blue": "Diagonale blu e lehtë majtas",
  "block.minecraft.banner.diagonal_left.light_gray": "Diagonale gri e lehtë majtas",
  "block.minecraft.banner.diagonal_left.lime": "Diagonale e gjelbër e çelët majtas",
  "block.minecraft.banner.diagonal_left.magenta": "Diagonale e purpurtë djathtas",
  "block.minecraft.banner.diagonal_left.orange": "Diagonale portokalli majtas",
  "block.minecraft.banner.diagonal_left.pink": "Diagonale rozë majtas",
  "block.minecraft.banner.diagonal_left.purple": "Diagonale vjollcë majtas",
  "block.minecraft.banner.diagonal_left.red": "Diagonale e kuqe majtas",
  "block.minecraft.banner.diagonal_left.white": "Diagonale e bardhë majtas",
  "block.minecraft.banner.diagonal_left.yellow": "Diagonale e verdhë majtas",
  "block.minecraft.banner.diagonal_right.black": "Diagonale e zezë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.blue": "Diagonale blu e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.brown": "Diagonale e kaftë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.cyan": "Diagonale cian e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.gray": "Diagonale gri e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.green": "Diagonale e gjelbër e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.light_blue": "Diagonale blu e lehtë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.light_gray": "Diagonale gri e lehtë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.lime": "Diagonale e gjelbër e çelët e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.magenta": "Diagonale e purpurtë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.orange": "Diagonale portokalli djathtas e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.pink": "Diagonale rozë djathtas e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.purple": "Diagonale vjollcë djathtas e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.red": "Diagonale e kuqe e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.white": "Diagonale e bardhë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_right.yellow": "Diagonale e verdhë e përmbysur djathtas",
  "block.minecraft.banner.diagonal_up_left.black": "Diagonale e zezë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.blue": "Diagonale blu e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.brown": "Diagonale e kaftë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.cyan": "Diagonale cian e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.gray": "Diagonale gri e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.green": "Diagonale e gjelbër e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Diagonale blu e lehtë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Diagonale gri e lehtë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.lime": "Diagonale e gjelbër e çelët e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.magenta": "Diagonale e purpurtë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.orange": "Diagonale portokalli e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.pink": "Diagonale rozë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.purple": "Diagonale vjollcë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.red": "Diagonale e kuqe e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.white": "Diagonale e bardhë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_left.yellow": "Diagonale e verdhë e përmbysur majtas",
  "block.minecraft.banner.diagonal_up_right.black": "Diagonale e zezë djathtas",
  "block.minecraft.banner.diagonal_up_right.blue": "Diagonale blu djathtas",
  "block.minecraft.banner.diagonal_up_right.brown": "Diagonale e kaftë djathtas",
  "block.minecraft.banner.diagonal_up_right.cyan": "Diagonale cian djathtas",
  "block.minecraft.banner.diagonal_up_right.gray": "Diagonale gri djathtas",
  "block.minecraft.banner.diagonal_up_right.green": "Diagonale e gjelbër djathtas",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Diagonale blu e lehtë djathtas",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Diagonale gri e lehtë djathtas",
  "block.minecraft.banner.diagonal_up_right.lime": "Diagonale e gjelbër e çelët djathtas",
  "block.minecraft.banner.diagonal_up_right.magenta": "Diagonale e purpurtë djathtas",
  "block.minecraft.banner.diagonal_up_right.orange": "Diagonale portokalli djathtas",
  "block.minecraft.banner.diagonal_up_right.pink": "Diagonale rozë djathtas",
  "block.minecraft.banner.diagonal_up_right.purple": "Diagonale vjollcë djathtas",
  "block.minecraft.banner.diagonal_up_right.red": "Diagonale e kuqe djathtas",
  "block.minecraft.banner.diagonal_up_right.white": "Diagonale e bardhë djathtas",
  "block.minecraft.banner.diagonal_up_right.yellow": "Diagonale e verdhë djathtas",
  "block.minecraft.banner.flow.black": "Vorbulla e zezë",
  "block.minecraft.banner.flow.blue": "Vorbulla blu",
  "block.minecraft.banner.flow.brown": "Vorbull e kaftë",
  "block.minecraft.banner.flow.cyan": "Vorbulla cian",
  "block.minecraft.banner.flow.gray": "Vorbulla gri",
  "block.minecraft.banner.flow.green": "Vorbulla e gjelbër",
  "block.minecraft.banner.flow.light_blue": "Vorbulla blu e lehtë",
  "block.minecraft.banner.flow.light_gray": "Vorbulla gri e lehtë",
  "block.minecraft.banner.flow.lime": "Vorbulla e gjelbër e çelët",
  "block.minecraft.banner.flow.magenta": "Vorbulla e purpurtë",
  "block.minecraft.banner.flow.orange": "Vorbulla portokalli",
  "block.minecraft.banner.flow.pink": "Vorbulla rozë",
  "block.minecraft.banner.flow.purple": "Vorbulla vjollcë",
  "block.minecraft.banner.flow.red": "Vorbulla e kuqe",
  "block.minecraft.banner.flow.white": "Vorbulla e bardhë",
  "block.minecraft.banner.flow.yellow": "Vorbulla e verdhë",
  "block.minecraft.banner.flower.black": "Lule e zezë",
  "block.minecraft.banner.flower.blue": "Lule blu",
  "block.minecraft.banner.flower.brown": "Lule e kaftë",
  "block.minecraft.banner.flower.cyan": "Lule cian",
  "block.minecraft.banner.flower.gray": "Lule gri",
  "block.minecraft.banner.flower.green": "Lule e gjelbër",
  "block.minecraft.banner.flower.light_blue": "Lule blu e lehtë",
  "block.minecraft.banner.flower.light_gray": "Lule gri e lehtë",
  "block.minecraft.banner.flower.lime": "Lule e gjelbër e çelët",
  "block.minecraft.banner.flower.magenta": "Lule purpurtë",
  "block.minecraft.banner.flower.orange": "Lule portokalli",
  "block.minecraft.banner.flower.pink": "Lule rozë",
  "block.minecraft.banner.flower.purple": "Lule vjollcë",
  "block.minecraft.banner.flower.red": "Lule e kuqe",
  "block.minecraft.banner.flower.white": "Lule e bardhë",
  "block.minecraft.banner.flower.yellow": "Lule e verdhë",
  "block.minecraft.banner.globe.black": "Glob i zi",
  "block.minecraft.banner.globe.blue": "Glob blu",
  "block.minecraft.banner.globe.brown": "Glob i kaftë",
  "block.minecraft.banner.globe.cyan": "Glob cian",
  "block.minecraft.banner.globe.gray": "Glob gri",
  "block.minecraft.banner.globe.green": "Glob i gjelbër",
  "block.minecraft.banner.globe.light_blue": "Glob blu e lehtë",
  "block.minecraft.banner.globe.light_gray": "Glob gri e lehtë",
  "block.minecraft.banner.globe.lime": "Glob i gjelbër e çelët",
  "block.minecraft.banner.globe.magenta": "Glob i purpurtë",
  "block.minecraft.banner.globe.orange": "Glob portokalli",
  "block.minecraft.banner.globe.pink": "Glob rozë",
  "block.minecraft.banner.globe.purple": "Glob vjollcë",
  "block.minecraft.banner.globe.red": "Glob i kuq",
  "block.minecraft.banner.globe.white": "Glob i bardhë",
  "block.minecraft.banner.globe.yellow": "Glob i verdhë",
  "block.minecraft.banner.gradient.black": "Gradient i zi",
  "block.minecraft.banner.gradient.blue": "Gradient blu",
  "block.minecraft.banner.gradient.brown": "Gradient i kaftë",
  "block.minecraft.banner.gradient.cyan": "Gradient cian",
  "block.minecraft.banner.gradient.gray": "Gradient gri",
  "block.minecraft.banner.gradient.green": "Gradient i gjelbër",
  "block.minecraft.banner.gradient.light_blue": "Gradient blu e lehtë",
  "block.minecraft.banner.gradient.light_gray": "Gradient gri e lehtë",
  "block.minecraft.banner.gradient.lime": "Gradient i gjelbër e çelët",
  "block.minecraft.banner.gradient.magenta": "Gradient i purpurtë",
  "block.minecraft.banner.gradient.orange": "Gradient portokalli",
  "block.minecraft.banner.gradient.pink": "Gradient rozë",
  "block.minecraft.banner.gradient.purple": "Gradient vjollcë",
  "block.minecraft.banner.gradient.red": "Gradient i kuq",
  "block.minecraft.banner.gradient.white": "Gradient i bardhë",
  "block.minecraft.banner.gradient.yellow": "Gradient i verdhë",
  "block.minecraft.banner.gradient_up.black": "Gradient i zi në krye",
  "block.minecraft.banner.gradient_up.blue": "Gradient blu në krye",
  "block.minecraft.banner.gradient_up.brown": "Gradient i kaftë në krye",
  "block.minecraft.banner.gradient_up.cyan": "Gradient cian në krye",
  "block.minecraft.banner.gradient_up.gray": "Gradient gri në krye",
  "block.minecraft.banner.gradient_up.green": "Gradient i gjelbër në krye",
  "block.minecraft.banner.gradient_up.light_blue": "Gradient blu e lehtë në krye",
  "block.minecraft.banner.gradient_up.light_gray": "Gradient gri e lehtë në krye",
  "block.minecraft.banner.gradient_up.lime": "Gradient i gjelbër e çelët në krye",
  "block.minecraft.banner.gradient_up.magenta": "Gradient i purpurtë në krye",
  "block.minecraft.banner.gradient_up.orange": "Gradient portokalli në krye",
  "block.minecraft.banner.gradient_up.pink": "Gradient rozë në krye",
  "block.minecraft.banner.gradient_up.purple": "Gradient vjollcë në krye",
  "block.minecraft.banner.gradient_up.red": "Gradient i kuq në krye",
  "block.minecraft.banner.gradient_up.white": "Gradient i bardhë në krye",
  "block.minecraft.banner.gradient_up.yellow": "Gradient i verdhë në krye",
  "block.minecraft.banner.guster.black": "Oshnik i zi",
  "block.minecraft.banner.guster.blue": "Oshnik blu",
  "block.minecraft.banner.guster.brown": "Oshnik i kaftë",
  "block.minecraft.banner.guster.cyan": "Oshnik cian",
  "block.minecraft.banner.guster.gray": "Oshnik gri",
  "block.minecraft.banner.guster.green": "Oshnik i gjelbër",
  "block.minecraft.banner.guster.light_blue": "Oshnik blu e lehtë",
  "block.minecraft.banner.guster.light_gray": "Oshnik gri e lehtë",
  "block.minecraft.banner.guster.lime": "Oshnik i gjelbër e çelët",
  "block.minecraft.banner.guster.magenta": "Oshnik i purpurtë",
  "block.minecraft.banner.guster.orange": "Oshnik portokalli",
  "block.minecraft.banner.guster.pink": "Oshnik rozë",
  "block.minecraft.banner.guster.purple": "Oshnik vjollcë",
  "block.minecraft.banner.guster.red": "Oshnik i kuq",
  "block.minecraft.banner.guster.white": "Oshnik i bardhë",
  "block.minecraft.banner.guster.yellow": "Oshnik i verdhë",
  "block.minecraft.banner.half_horizontal.black": "Gjysmë horizontale e sipërme e zezë",
  "block.minecraft.banner.half_horizontal.blue": "Gjysmë horizontale e sipërme blu",
  "block.minecraft.banner.half_horizontal.brown": "Gjysmë horizontale e sipërme e kaftë",
  "block.minecraft.banner.half_horizontal.cyan": "Gjysmë horizontale e sipërme cian",
  "block.minecraft.banner.half_horizontal.gray": "Gjysmë horizontale e sipërme gri",
  "block.minecraft.banner.half_horizontal.green": "Gjysmë horizontale e sipërme e gjelbër",
  "block.minecraft.banner.half_horizontal.light_blue": "Gjysmë horizontale e sipërme blu e lehtë",
  "block.minecraft.banner.half_horizontal.light_gray": "Gjysmë horizontale e sipërme gri e lehtë",
  "block.minecraft.banner.half_horizontal.lime": "Gjysmë horizontale e sipërme e gjelbër e çelët",
  "block.minecraft.banner.half_horizontal.magenta": "Gjysmë horizontale e sipërme e purpurtë",
  "block.minecraft.banner.half_horizontal.orange": "Gjysmë horizontale e sipërme portokalli",
  "block.minecraft.banner.half_horizontal.pink": "Gjysmë horizontale e sipërme rozë",
  "block.minecraft.banner.half_horizontal.purple": "Gjysmë horizontale e sipërme vjollcë",
  "block.minecraft.banner.half_horizontal.red": "Gjysmë horizontale e sipërme e kuqe",
  "block.minecraft.banner.half_horizontal.white": "Gjysmë horizontale e sipërme e bardhë",
  "block.minecraft.banner.half_horizontal.yellow": "Gjysmë horizontale e sipërme e verdhë",
  "block.minecraft.banner.half_horizontal_bottom.black": "Gjysmë horizontale e zezë",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Gjysmë horizontale blu",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Gjysmë horizontale e kaftë",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Gjysmë horizontale cian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gjysmë horizontale gri",
  "block.minecraft.banner.half_horizontal_bottom.green": "Gjysmë horizontale e gjelbër",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Gjysmë horizontale blu e lehtë",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Gjysmë horizontale gri e lehtë",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Gjysmë horizontale e gjelbër e çelët",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Gjysmë horizontale e purpurtë",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Gjysmë horizontale portokalli",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Gjysmë horizontale rozë",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Gjysmë horizontale vjollcë",
  "block.minecraft.banner.half_horizontal_bottom.red": "Gjysmë horizontale e kuqe",
  "block.minecraft.banner.half_horizontal_bottom.white": "Gjysmë horizontale e bardhë",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gjysmë horizontale e verdhë",
  "block.minecraft.banner.half_vertical.black": "Gjysmë vertikale majtas e zezë",
  "block.minecraft.banner.half_vertical.blue": "Gjysmë vertikale majtas blu",
  "block.minecraft.banner.half_vertical.brown": "Gjysmë vertikale majtas e kaftë",
  "block.minecraft.banner.half_vertical.cyan": "Gjysmë vertikale majtas cian",
  "block.minecraft.banner.half_vertical.gray": "Gjysmë vertikale majtas gri",
  "block.minecraft.banner.half_vertical.green": "Gjysmë vertikale majtas e gjelbër",
  "block.minecraft.banner.half_vertical.light_blue": "Gjysmë vertikale majtas blu e lehtë",
  "block.minecraft.banner.half_vertical.light_gray": "Gjysmë vertikale majtas gri e lehtë",
  "block.minecraft.banner.half_vertical.lime": "Gjysmë vertikale majtas e gjelbër e çelët",
  "block.minecraft.banner.half_vertical.magenta": "Gjysmë vertikale majtas e purpurtë",
  "block.minecraft.banner.half_vertical.orange": "Gjysmë vertikale majtas portokalli",
  "block.minecraft.banner.half_vertical.pink": "Gjysmë vertikale majtas rozë",
  "block.minecraft.banner.half_vertical.purple": "Gjysmë vertikale majtas vjollcë",
  "block.minecraft.banner.half_vertical.red": "Gjysmë vertikale majtas e kuqe",
  "block.minecraft.banner.half_vertical.white": "Gjysmë vertikale majtas e bardhë",
  "block.minecraft.banner.half_vertical.yellow": "Gjysmë vertikale majtas e verdhë",
  "block.minecraft.banner.half_vertical_right.black": "Gjysmë vertikale djathas e zezë",
  "block.minecraft.banner.half_vertical_right.blue": "Gjysmë vertikale djathas blu",
  "block.minecraft.banner.half_vertical_right.brown": "Gjysmë vertikale djathas e kaftë",
  "block.minecraft.banner.half_vertical_right.cyan": "Gjysmë vertikale djathas cian",
  "block.minecraft.banner.half_vertical_right.gray": "Gjysmë vertikale djathas gri",
  "block.minecraft.banner.half_vertical_right.green": "Gjysmë vertikale djathas e gjelbër",
  "block.minecraft.banner.half_vertical_right.light_blue": "Gjysmë vertikale djathas blu e lehtë",
  "block.minecraft.banner.half_vertical_right.light_gray": "Gjysmë vertikale djathas gri e lehtë",
  "block.minecraft.banner.half_vertical_right.lime": "Gjysmë vertikale djathas e gjelbër e çelët",
  "block.minecraft.banner.half_vertical_right.magenta": "Gjysmë vertikale djathas e purpurtë",
  "block.minecraft.banner.half_vertical_right.orange": "Gjysmë vertikale djathas portokalli",
  "block.minecraft.banner.half_vertical_right.pink": "Gjysmë vertikale djathas rozë",
  "block.minecraft.banner.half_vertical_right.purple": "Gjysmë vertikale djathas vjollcë",
  "block.minecraft.banner.half_vertical_right.red": "Gjysmë vertikale djathas e kuqe",
  "block.minecraft.banner.half_vertical_right.white": "Gjysmë vertikale djathas e bardhë",
  "block.minecraft.banner.half_vertical_right.yellow": "Gjysmë vertikale djathas e verdhë",
  "block.minecraft.banner.mojang.black": "Stemë e zezë",
  "block.minecraft.banner.mojang.blue": "Stemë blu",
  "block.minecraft.banner.mojang.brown": "Stemë e kaftë",
  "block.minecraft.banner.mojang.cyan": "Stemë cian",
  "block.minecraft.banner.mojang.gray": "Stemë gri",
  "block.minecraft.banner.mojang.green": "Stemë e gjelbër",
  "block.minecraft.banner.mojang.light_blue": "Stemë blu e lehtë",
  "block.minecraft.banner.mojang.light_gray": "Stemë gri e lehtë",
  "block.minecraft.banner.mojang.lime": "Stemë e gjelbër e çelët",
  "block.minecraft.banner.mojang.magenta": "Stemë e purpurtë",
  "block.minecraft.banner.mojang.orange": "Stemë portokalli",
  "block.minecraft.banner.mojang.pink": "Stemë rozë",
  "block.minecraft.banner.mojang.purple": "Stemë vjollcë",
  "block.minecraft.banner.mojang.red": "Stemë e kuqe",
  "block.minecraft.banner.mojang.white": "Stemë e bardhë",
  "block.minecraft.banner.mojang.yellow": "Stemë e verdhë",
  "block.minecraft.banner.piglin.black": "Feçkë e zezë",
  "block.minecraft.banner.piglin.blue": "Feçkë e kaltër",
  "block.minecraft.banner.piglin.brown": "Feçkë e kaftë",
  "block.minecraft.banner.piglin.cyan": "Feçkë cian",
  "block.minecraft.banner.piglin.gray": "Feçkë gri",
  "block.minecraft.banner.piglin.green": "Feçkë e gjelbërt",
  "block.minecraft.banner.piglin.light_blue": "Feçkë blu e lehtë",
  "block.minecraft.banner.piglin.light_gray": "Feçkë gri e lehtë",
  "block.minecraft.banner.piglin.lime": "Feçkë gjelbër e çelët",
  "block.minecraft.banner.piglin.magenta": "Feçkë purpurtë",
  "block.minecraft.banner.piglin.orange": "Feçkë portokalli",
  "block.minecraft.banner.piglin.pink": "Feçkë rozë",
  "block.minecraft.banner.piglin.purple": "Feçkë vjollcë",
  "block.minecraft.banner.piglin.red": "Feçkë e kuqe",
  "block.minecraft.banner.piglin.white": "Feçkë e bardhë",
  "block.minecraft.banner.piglin.yellow": "Feçkë e verdhë",
  "block.minecraft.banner.rhombus.black": "Romb i zi",
  "block.minecraft.banner.rhombus.blue": "Romb blu",
  "block.minecraft.banner.rhombus.brown": "Romb i kaftë",
  "block.minecraft.banner.rhombus.cyan": "Romb cian",
  "block.minecraft.banner.rhombus.gray": "Romb gri",
  "block.minecraft.banner.rhombus.green": "Romb i gjelbër",
  "block.minecraft.banner.rhombus.light_blue": "Romb blu e lehtë",
  "block.minecraft.banner.rhombus.light_gray": "Romb gri e lehtë",
  "block.minecraft.banner.rhombus.lime": "Romb i gjelbër e çelët",
  "block.minecraft.banner.rhombus.magenta": "Romb i purpurtë",
  "block.minecraft.banner.rhombus.orange": "Romb portokalli",
  "block.minecraft.banner.rhombus.pink": "Romb rozë",
  "block.minecraft.banner.rhombus.purple": "Romb vjollcë",
  "block.minecraft.banner.rhombus.red": "Romb i kuq",
  "block.minecraft.banner.rhombus.white": "Romb i bardhë",
  "block.minecraft.banner.rhombus.yellow": "Romb i verdhë",
  "block.minecraft.banner.skull.black": "Kafkë e zezë",
  "block.minecraft.banner.skull.blue": "Kafkë blu",
  "block.minecraft.banner.skull.brown": "Kafkë e kaftë",
  "block.minecraft.banner.skull.cyan": "Kafkë cian",
  "block.minecraft.banner.skull.gray": "Kafkë gri",
  "block.minecraft.banner.skull.green": "Kafkë e gjelbër",
  "block.minecraft.banner.skull.light_blue": "Kafkë blu e lehtë",
  "block.minecraft.banner.skull.light_gray": "Kafkë gri e lehtë",
  "block.minecraft.banner.skull.lime": "Kafkë e gjelbër e çelët",
  "block.minecraft.banner.skull.magenta": "Kafkë e purpurtë",
  "block.minecraft.banner.skull.orange": "Kafkë portokalli",
  "block.minecraft.banner.skull.pink": "Kafkë rozë",
  "block.minecraft.banner.skull.purple": "Kafkë vjollcë",
  "block.minecraft.banner.skull.red": "Kafkë e kuqe",
  "block.minecraft.banner.skull.white": "Kafkë e bardhë",
  "block.minecraft.banner.skull.yellow": "Kafkë e verdhë",
  "block.minecraft.banner.small_stripes.black": "Katër vija të zezë",
  "block.minecraft.banner.small_stripes.blue": "Katër vija blu",
  "block.minecraft.banner.small_stripes.brown": "Katër vija të kaftë",
  "block.minecraft.banner.small_stripes.cyan": "Katër vija cian",
  "block.minecraft.banner.small_stripes.gray": "Katër vija gri",
  "block.minecraft.banner.small_stripes.green": "Katër vija të gjelbër",
  "block.minecraft.banner.small_stripes.light_blue": "Katër vija blu e lehtë",
  "block.minecraft.banner.small_stripes.light_gray": "Katër vija gri e lehtë",
  "block.minecraft.banner.small_stripes.lime": "Katër vija të gjelbër e çelët",
  "block.minecraft.banner.small_stripes.magenta": "Katër vija të purpurtë",
  "block.minecraft.banner.small_stripes.orange": "Katër vija portokalli",
  "block.minecraft.banner.small_stripes.pink": "Katër vija rozë",
  "block.minecraft.banner.small_stripes.purple": "Katër vija vjollcë",
  "block.minecraft.banner.small_stripes.red": "Katër vija të kuq",
  "block.minecraft.banner.small_stripes.white": "Katër vija të bardhë",
  "block.minecraft.banner.small_stripes.yellow": "Katër vija të verdhë",
  "block.minecraft.banner.square_bottom_left.black": "Këndi i poshtëm majtas i zi",
  "block.minecraft.banner.square_bottom_left.blue": "Këndi i poshtëm majtas blu",
  "block.minecraft.banner.square_bottom_left.brown": "Këndi i poshtëm majtas i kaftë",
  "block.minecraft.banner.square_bottom_left.cyan": "Këndi i poshtëm majtas cian",
  "block.minecraft.banner.square_bottom_left.gray": "Këndi i poshtëm majtas gri",
  "block.minecraft.banner.square_bottom_left.green": "Këndi i poshtëm majtas i gjelbër",
  "block.minecraft.banner.square_bottom_left.light_blue": "Këndi i poshtëm majtas blu e lehtë",
  "block.minecraft.banner.square_bottom_left.light_gray": "Këndi i poshtëm majtas gri e lehtë",
  "block.minecraft.banner.square_bottom_left.lime": "Këndi i poshtëm majtas i gjelbër e çelët",
  "block.minecraft.banner.square_bottom_left.magenta": "Këndi i poshtëm majtas i purpurtë",
  "block.minecraft.banner.square_bottom_left.orange": "Këndi i poshtëm majtas portokalli",
  "block.minecraft.banner.square_bottom_left.pink": "Këndi i poshtëm majtas rozë",
  "block.minecraft.banner.square_bottom_left.purple": "Këndi i poshtëm majtas vjollcë",
  "block.minecraft.banner.square_bottom_left.red": "Këndi i poshtëm majtas i kuq",
  "block.minecraft.banner.square_bottom_left.white": "Këndi i poshtëm majtas i bardhë",
  "block.minecraft.banner.square_bottom_left.yellow": "Këndi i poshtëm majtas i verdhë",
  "block.minecraft.banner.square_bottom_right.black": "Këndi i poshtëm djathtas i zi",
  "block.minecraft.banner.square_bottom_right.blue": "Këndi i poshtëm djathtas blu",
  "block.minecraft.banner.square_bottom_right.brown": "Këndi i poshtëm djathtas i kaftë",
  "block.minecraft.banner.square_bottom_right.cyan": "Këndi i poshtëm djathtas cian",
  "block.minecraft.banner.square_bottom_right.gray": "Këndi i poshtëm djathtas gri",
  "block.minecraft.banner.square_bottom_right.green": "Këndi i poshtëm djathtas i gjelbër",
  "block.minecraft.banner.square_bottom_right.light_blue": "Këndi i poshtëm djathtas blu e lehtë",
  "block.minecraft.banner.square_bottom_right.light_gray": "Këndi i poshtëm djathtas gri e lehtë",
  "block.minecraft.banner.square_bottom_right.lime": "Këndi i poshtëm djathtas i gjelbër e çelët",
  "block.minecraft.banner.square_bottom_right.magenta": "Këndi i poshtëm djathtas i purpurtë",
  "block.minecraft.banner.square_bottom_right.orange": "Këndi i poshtëm djathtas portokalli",
  "block.minecraft.banner.square_bottom_right.pink": "Këndi i poshtëm djathtas rozë",
  "block.minecraft.banner.square_bottom_right.purple": "Këndi i poshtëm djathtas vjollcë",
  "block.minecraft.banner.square_bottom_right.red": "Këndi i poshtëm djathtas i kuq",
  "block.minecraft.banner.square_bottom_right.white": "Këndi i poshtëm djathtas i bardhë",
  "block.minecraft.banner.square_bottom_right.yellow": "Këndi i poshtëm djathtas i verdhë",
  "block.minecraft.banner.square_top_left.black": "Këndi i sipërm majtas i zi",
  "block.minecraft.banner.square_top_left.blue": "Këndi i sipërm majtas blu",
  "block.minecraft.banner.square_top_left.brown": "Këndi i sipërm majtas i kaftë",
  "block.minecraft.banner.square_top_left.cyan": "Këndi i sipërm majtas cian",
  "block.minecraft.banner.square_top_left.gray": "Këndi i sipërm majtas gri",
  "block.minecraft.banner.square_top_left.green": "Këndi i sipërm majtas i gjelbër",
  "block.minecraft.banner.square_top_left.light_blue": "Këndi i sipërm majtas blu e lehtë",
  "block.minecraft.banner.square_top_left.light_gray": "Këndi i sipërm majtas gri e lehtë",
  "block.minecraft.banner.square_top_left.lime": "Këndi i sipërm majtas i gjelbër e çelët",
  "block.minecraft.banner.square_top_left.magenta": "Këndi i sipërm majtas i purpurtë",
  "block.minecraft.banner.square_top_left.orange": "Këndi i sipërm majtas portokalli",
  "block.minecraft.banner.square_top_left.pink": "Këndi i sipërm majtas rozë",
  "block.minecraft.banner.square_top_left.purple": "Këndi i sipërm majtas vjollcë",
  "block.minecraft.banner.square_top_left.red": "Këndi i sipërm majtas i kuq",
  "block.minecraft.banner.square_top_left.white": "Këndi i sipërm majtas i bardhë",
  "block.minecraft.banner.square_top_left.yellow": "Këndi i sipërm majtas i verdhë",
  "block.minecraft.banner.square_top_right.black": "Këndi i sipërm djathtas i zi",
  "block.minecraft.banner.square_top_right.blue": "Këndi i sipërm djathtas blu",
  "block.minecraft.banner.square_top_right.brown": "Këndi i sipërm djathtas i kaftë",
  "block.minecraft.banner.square_top_right.cyan": "Këndi i sipërm djathtas cian",
  "block.minecraft.banner.square_top_right.gray": "Këndi i sipërm djathtas gri",
  "block.minecraft.banner.square_top_right.green": "Këndi i sipërm djathtas i gjelbër",
  "block.minecraft.banner.square_top_right.light_blue": "Këndi i sipërm djathtas blu e lehtë",
  "block.minecraft.banner.square_top_right.light_gray": "Këndi i sipërm djathtas gri e lehtë",
  "block.minecraft.banner.square_top_right.lime": "Këndi i sipërm djathtas i gjelbër e çelët",
  "block.minecraft.banner.square_top_right.magenta": "Këndi i sipërm djathtas i purpurtë",
  "block.minecraft.banner.square_top_right.orange": "Këndi i sipërm djathtas portokalli",
  "block.minecraft.banner.square_top_right.pink": "Këndi i sipërm djathtas rozë",
  "block.minecraft.banner.square_top_right.purple": "Këndi i sipërm djathtas vjollcë",
  "block.minecraft.banner.square_top_right.red": "Këndi i sipërm djathtas i kuq",
  "block.minecraft.banner.square_top_right.white": "Këndi i sipërm djathtas i bardhë",
  "block.minecraft.banner.square_top_right.yellow": "Këndi i sipërm djathtas i verdhë",
  "block.minecraft.banner.straight_cross.black": "Kryq i zi i drejtë",
  "block.minecraft.banner.straight_cross.blue": "Kryq blu i drejtë",
  "block.minecraft.banner.straight_cross.brown": "Kryq i kaftë i drejtë",
  "block.minecraft.banner.straight_cross.cyan": "Kryq cian i drejtë",
  "block.minecraft.banner.straight_cross.gray": "Kryq gri i drejtë",
  "block.minecraft.banner.straight_cross.green": "Kryq i gjelbër i drejtë",
  "block.minecraft.banner.straight_cross.light_blue": "Kryq blu e lehtë i drejtë",
  "block.minecraft.banner.straight_cross.light_gray": "Kryq gri e lehtë i drejtë",
  "block.minecraft.banner.straight_cross.lime": "Kryq i gjelbër e çelët i drejtë",
  "block.minecraft.banner.straight_cross.magenta": "Kryq i purpurtë i drejtë",
  "block.minecraft.banner.straight_cross.orange": "Kryq portokalli i drejtë",
  "block.minecraft.banner.straight_cross.pink": "Kryq rozë i drejtë",
  "block.minecraft.banner.straight_cross.purple": "Kryq vjollcë i drejtë",
  "block.minecraft.banner.straight_cross.red": "Kryq i kuq i drejtë",
  "block.minecraft.banner.straight_cross.white": "Kryq i bardhë i drejtë",
  "block.minecraft.banner.straight_cross.yellow": "Kryq i verdhë i drejtë",
  "block.minecraft.banner.stripe_bottom.black": "Bazë e zezë",
  "block.minecraft.banner.stripe_bottom.blue": "Bazë blu",
  "block.minecraft.banner.stripe_bottom.brown": "Bazë e kaftë",
  "block.minecraft.banner.stripe_bottom.cyan": "Bazë cian",
  "block.minecraft.banner.stripe_bottom.gray": "Bazë gri",
  "block.minecraft.banner.stripe_bottom.green": "Bazë e gjelbër",
  "block.minecraft.banner.stripe_bottom.light_blue": "Bazë blu e lehtë",
  "block.minecraft.banner.stripe_bottom.light_gray": "Bazë gri e lehtë",
  "block.minecraft.banner.stripe_bottom.lime": "Bazë e gjelbër e çelët",
  "block.minecraft.banner.stripe_bottom.magenta": "Bazë e purpurtë",
  "block.minecraft.banner.stripe_bottom.orange": "Bazë portokalli",
  "block.minecraft.banner.stripe_bottom.pink": "Bazë rozë",
  "block.minecraft.banner.stripe_bottom.purple": "Bazë vjollcë",
  "block.minecraft.banner.stripe_bottom.red": "Bazë e kuqe",
  "block.minecraft.banner.stripe_bottom.white": "Bazë e bardhë",
  "block.minecraft.banner.stripe_bottom.yellow": "Bazë e verdhë",
  "block.minecraft.banner.stripe_center.black": "Kolonë e zezë",
  "block.minecraft.banner.stripe_center.blue": "Kolonë blu",
  "block.minecraft.banner.stripe_center.brown": "Kolonë e kaftë",
  "block.minecraft.banner.stripe_center.cyan": "Kolonë cian",
  "block.minecraft.banner.stripe_center.gray": "Kolonë gri",
  "block.minecraft.banner.stripe_center.green": "Kolonë e gjelbër",
  "block.minecraft.banner.stripe_center.light_blue": "Kolonë blu e lehtë",
  "block.minecraft.banner.stripe_center.light_gray": "Kolonë gri e lehtë",
  "block.minecraft.banner.stripe_center.lime": "Kolonë e gjelbër e çelët",
  "block.minecraft.banner.stripe_center.magenta": "Kolonë e purpurtë",
  "block.minecraft.banner.stripe_center.orange": "Kolonë portokalli",
  "block.minecraft.banner.stripe_center.pink": "Kolonë rozë",
  "block.minecraft.banner.stripe_center.purple": "Kolonë vjollcë",
  "block.minecraft.banner.stripe_center.red": "Kolonë e kuqe",
  "block.minecraft.banner.stripe_center.white": "Kolonë e bardhë",
  "block.minecraft.banner.stripe_center.yellow": "Kolonë e verdhë",
  "block.minecraft.banner.stripe_downleft.black": "Vijë diagonale e zezë majtas",
  "block.minecraft.banner.stripe_downleft.blue": "Vijë diagonale blu majtas",
  "block.minecraft.banner.stripe_downleft.brown": "Vijë diagonale e kaftë majtas",
  "block.minecraft.banner.stripe_downleft.cyan": "Vijë diagonale cian majtas",
  "block.minecraft.banner.stripe_downleft.gray": "Vijë diagonale gri majtas",
  "block.minecraft.banner.stripe_downleft.green": "Vijë diagonale e gjelbër majtas",
  "block.minecraft.banner.stripe_downleft.light_blue": "Vijë diagonale blu e lehtë majtas",
  "block.minecraft.banner.stripe_downleft.light_gray": "Vijë diagonale gri e lehtë majtas",
  "block.minecraft.banner.stripe_downleft.lime": "Vijë diagonale e gjelbër e çelët majtas",
  "block.minecraft.banner.stripe_downleft.magenta": "Vijë diagonale e purpurtë majtas",
  "block.minecraft.banner.stripe_downleft.orange": "Vijë diagonale portokalli majtas",
  "block.minecraft.banner.stripe_downleft.pink": "Vijë diagonale rozë majtas",
  "block.minecraft.banner.stripe_downleft.purple": "Vijë diagonale vjollcë majtas",
  "block.minecraft.banner.stripe_downleft.red": "Vijë diagonale e kuqe majtas",
  "block.minecraft.banner.stripe_downleft.white": "Vijë diagonale e bardhë majtas",
  "block.minecraft.banner.stripe_downleft.yellow": "Vijë diagonale e verdhë majtas",
  "block.minecraft.banner.stripe_downright.black": "Vijë diagonale e zezë djathtas",
  "block.minecraft.banner.stripe_downright.blue": "Vijë diagonale blu djathtas",
  "block.minecraft.banner.stripe_downright.brown": "Vijë diagonale e kaftë djathtas",
  "block.minecraft.banner.stripe_downright.cyan": "Vijë diagonale cian djathtas",
  "block.minecraft.banner.stripe_downright.gray": "Vijë diagonale gri djathtas",
  "block.minecraft.banner.stripe_downright.green": "Vijë diagonale e gjelbër djathtas",
  "block.minecraft.banner.stripe_downright.light_blue": "Vijë diagonale blu e lehtë djathtas",
  "block.minecraft.banner.stripe_downright.light_gray": "Vijë diagonale gri e lehtë djathtas",
  "block.minecraft.banner.stripe_downright.lime": "Vijë diagonale e gjelbër e çelët djathtas",
  "block.minecraft.banner.stripe_downright.magenta": "Vijë diagonale e purpurtë djathtas",
  "block.minecraft.banner.stripe_downright.orange": "Vijë diagonale portokalli djathtas",
  "block.minecraft.banner.stripe_downright.pink": "Vijë diagonale rozë djathtas",
  "block.minecraft.banner.stripe_downright.purple": "Vijë diagonale vjollcë djathtas",
  "block.minecraft.banner.stripe_downright.red": "Vijë diagonale e kuqe djathtas",
  "block.minecraft.banner.stripe_downright.white": "Vijë diagonale e bardhë djathtas",
  "block.minecraft.banner.stripe_downright.yellow": "Vijë diagonale e verdhë djathtas",
  "block.minecraft.banner.stripe_left.black": "Kolonë majtas e zezë",
  "block.minecraft.banner.stripe_left.blue": "Kolonë majtas blu",
  "block.minecraft.banner.stripe_left.brown": "Kolonë majtas e kaftë",
  "block.minecraft.banner.stripe_left.cyan": "Kolonë majtas cian",
  "block.minecraft.banner.stripe_left.gray": "Kolonë majtas gri",
  "block.minecraft.banner.stripe_left.green": "Kolonë majtas e gjelbër",
  "block.minecraft.banner.stripe_left.light_blue": "Kolonë majtas blu e lehtë",
  "block.minecraft.banner.stripe_left.light_gray": "Kolonë majtas gri e lehtë",
  "block.minecraft.banner.stripe_left.lime": "Kolonë majtas e gjelbër e çelët",
  "block.minecraft.banner.stripe_left.magenta": "Kolonë majtas e purpurtë",
  "block.minecraft.banner.stripe_left.orange": "Kolonë majtas portokalli",
  "block.minecraft.banner.stripe_left.pink": "Kolonë majtas rozë",
  "block.minecraft.banner.stripe_left.purple": "Kolonë majtas vjollcë",
  "block.minecraft.banner.stripe_left.red": "Kolonë majtas e kuqe",
  "block.minecraft.banner.stripe_left.white": "Kolonë majtas e bardhë",
  "block.minecraft.banner.stripe_left.yellow": "Kolonë majtas e verdhë",
  "block.minecraft.banner.stripe_middle.black": "Vijë horizontale e zezë",
  "block.minecraft.banner.stripe_middle.blue": "Vijë horizontale blu",
  "block.minecraft.banner.stripe_middle.brown": "Vijë horizontale e kaftë",
  "block.minecraft.banner.stripe_middle.cyan": "Vijë horizontale cian",
  "block.minecraft.banner.stripe_middle.gray": "Vijë horizontale gri",
  "block.minecraft.banner.stripe_middle.green": "Vijë horizontale e gjelbër",
  "block.minecraft.banner.stripe_middle.light_blue": "Vijë horizontale blu e lehtë",
  "block.minecraft.banner.stripe_middle.light_gray": "Vijë horizontale gri e lehtë",
  "block.minecraft.banner.stripe_middle.lime": "Vijë horizontale e gjelbër e çelët",
  "block.minecraft.banner.stripe_middle.magenta": "Vijë horizontale e purpurtë",
  "block.minecraft.banner.stripe_middle.orange": "Vijë horizontale portokalli",
  "block.minecraft.banner.stripe_middle.pink": "Vijë horizontale rozë",
  "block.minecraft.banner.stripe_middle.purple": "Vijë horizontale vjollcë",
  "block.minecraft.banner.stripe_middle.red": "Vijë horizontale e kuqe",
  "block.minecraft.banner.stripe_middle.white": "Vijë horizontale e bardhë",
  "block.minecraft.banner.stripe_middle.yellow": "Vijë horizontale e verdhë",
  "block.minecraft.banner.stripe_right.black": "Kolonë djathtas e zezë",
  "block.minecraft.banner.stripe_right.blue": "Kolonë djathtas blu",
  "block.minecraft.banner.stripe_right.brown": "Kolonë djathtas e kaftë",
  "block.minecraft.banner.stripe_right.cyan": "Kolonë djathtas cian",
  "block.minecraft.banner.stripe_right.gray": "Kolonë djathtas gri",
  "block.minecraft.banner.stripe_right.green": "Kolonë djathtas e gjelbër",
  "block.minecraft.banner.stripe_right.light_blue": "Kolonë djathtas blu e lehtë",
  "block.minecraft.banner.stripe_right.light_gray": "Kolonë djathtas gri e lehtë",
  "block.minecraft.banner.stripe_right.lime": "Kolonë djathtas e gjelbër e çelët",
  "block.minecraft.banner.stripe_right.magenta": "Kolonë djathtas e purpurtë",
  "block.minecraft.banner.stripe_right.orange": "Kolonë djathtas portokalli",
  "block.minecraft.banner.stripe_right.pink": "Kolonë djathtas rozë",
  "block.minecraft.banner.stripe_right.purple": "Kolonë djathtas vjollcë",
  "block.minecraft.banner.stripe_right.red": "Kolonë djathtas e kuqe",
  "block.minecraft.banner.stripe_right.white": "Kolonë djathtas e bardhë",
  "block.minecraft.banner.stripe_right.yellow": "Kolonë djathtas e verdhë",
  "block.minecraft.banner.stripe_top.black": "Vijë e sipërme e zezë",
  "block.minecraft.banner.stripe_top.blue": "Vijë e sipërme blu",
  "block.minecraft.banner.stripe_top.brown": "Vijë e sipërme e kaftë",
  "block.minecraft.banner.stripe_top.cyan": "Vijë e sipërme cian",
  "block.minecraft.banner.stripe_top.gray": "Vijë e sipërme gri",
  "block.minecraft.banner.stripe_top.green": "Vijë e sipërme e gjelbër",
  "block.minecraft.banner.stripe_top.light_blue": "Vijë e sipërme blu e lehtë",
  "block.minecraft.banner.stripe_top.light_gray": "Vijë e sipërme gri e lehtë",
  "block.minecraft.banner.stripe_top.lime": "Vijë e sipërme e gjelbër e çelët",
  "block.minecraft.banner.stripe_top.magenta": "Vijë e sipërme e purpurtë",
  "block.minecraft.banner.stripe_top.orange": "Vijë e sipërme portokalli",
  "block.minecraft.banner.stripe_top.pink": "Vijë e sipërme rozë",
  "block.minecraft.banner.stripe_top.purple": "Vijë e sipërme vjollcë",
  "block.minecraft.banner.stripe_top.red": "Vijë e sipërme e kuqe",
  "block.minecraft.banner.stripe_top.white": "Vijë e sipërme e bardhë",
  "block.minecraft.banner.stripe_top.yellow": "Vijë e sipërme e verdhë",
  "block.minecraft.banner.triangle_bottom.black": "Trekëndësh i zi poshtë",
  "block.minecraft.banner.triangle_bottom.blue": "Trekëndësh blu poshtë",
  "block.minecraft.banner.triangle_bottom.brown": "Trekëndësh i kaftë poshtë",
  "block.minecraft.banner.triangle_bottom.cyan": "Trekëndësh cian poshtë",
  "block.minecraft.banner.triangle_bottom.gray": "Trekëndësh gri poshtë",
  "block.minecraft.banner.triangle_bottom.green": "Trekëndësh i gjelbër poshtë",
  "block.minecraft.banner.triangle_bottom.light_blue": "Trekëndësh blu e lehtë poshtë",
  "block.minecraft.banner.triangle_bottom.light_gray": "Trekëndësh gri e lehtë poshtë",
  "block.minecraft.banner.triangle_bottom.lime": "Trekëndësh i gjelbër e çelët poshtë",
  "block.minecraft.banner.triangle_bottom.magenta": "Trekëndësh i purpurtë poshtë",
  "block.minecraft.banner.triangle_bottom.orange": "Trekëndësh portokalli poshtë",
  "block.minecraft.banner.triangle_bottom.pink": "Trekëndësh rozë poshtë",
  "block.minecraft.banner.triangle_bottom.purple": "Trekëndësh vjollcë poshtë",
  "block.minecraft.banner.triangle_bottom.red": "Trekëndësh i kuq poshtë",
  "block.minecraft.banner.triangle_bottom.white": "Trekëndësh i bardhë poshtë",
  "block.minecraft.banner.triangle_bottom.yellow": "Trekëndësh i verdhë poshtë",
  "block.minecraft.banner.triangle_top.black": "Trekëndësh i zi naltë",
  "block.minecraft.banner.triangle_top.blue": "Trekëndësh blu naltë",
  "block.minecraft.banner.triangle_top.brown": "Trekëndësh i kaftë naltë",
  "block.minecraft.banner.triangle_top.cyan": "Trekëndësh cian naltë",
  "block.minecraft.banner.triangle_top.gray": "Trekëndësh gri naltë",
  "block.minecraft.banner.triangle_top.green": "Trekëndësh i gjelbër naltë",
  "block.minecraft.banner.triangle_top.light_blue": "Trekëndësh blu e lehtë naltë",
  "block.minecraft.banner.triangle_top.light_gray": "Trekëndësh gri e lehtë naltë",
  "block.minecraft.banner.triangle_top.lime": "Trekëndësh i gjelbër e çelët naltë",
  "block.minecraft.banner.triangle_top.magenta": "Trekëndësh i purpurtë naltë",
  "block.minecraft.banner.triangle_top.orange": "Trekëndësh portokalli naltë",
  "block.minecraft.banner.triangle_top.pink": "Trekëndësh rozë naltë",
  "block.minecraft.banner.triangle_top.purple": "Trekëndësh vjollcë naltë",
  "block.minecraft.banner.triangle_top.red": "Trekëndësh i kuq naltë",
  "block.minecraft.banner.triangle_top.white": "Trekëndësh i bardhë naltë",
  "block.minecraft.banner.triangle_top.yellow": "Trekëndësh i verdhë naltë",
  "block.minecraft.banner.triangles_bottom.black": "Bazë trekëndëshe e zezë",
  "block.minecraft.banner.triangles_bottom.blue": "Bazë trekëndëshe blu",
  "block.minecraft.banner.triangles_bottom.brown": "Bazë trekëndëshe e kaftë",
  "block.minecraft.banner.triangles_bottom.cyan": "Bazë trekëndëshe cian",
  "block.minecraft.banner.triangles_bottom.gray": "Bazë trekëndëshe gri",
  "block.minecraft.banner.triangles_bottom.green": "Bazë trekëndëshe e gjelbër",
  "block.minecraft.banner.triangles_bottom.light_blue": "Bazë trekëndëshe blu e lehtë",
  "block.minecraft.banner.triangles_bottom.light_gray": "Bazë trekëndëshe gri e lehtë",
  "block.minecraft.banner.triangles_bottom.lime": "Bazë trekëndëshe e gjelbër e çelët",
  "block.minecraft.banner.triangles_bottom.magenta": "Bazë trekëndëshe e purpurtë",
  "block.minecraft.banner.triangles_bottom.orange": "Bazë trekëndëshe portokalli",
  "block.minecraft.banner.triangles_bottom.pink": "Bazë trekëndëshe rozë",
  "block.minecraft.banner.triangles_bottom.purple": "Bazë trekëndëshe vjollcë",
  "block.minecraft.banner.triangles_bottom.red": "Bazë trekëndëshe e kuqe",
  "block.minecraft.banner.triangles_bottom.white": "Bazë trekëndëshe e bardhë",
  "block.minecraft.banner.triangles_bottom.yellow": "Bazë trekëndëshe e verdhë",
  "block.minecraft.banner.triangles_top.black": "Majë trekëndëshe e zezë",
  "block.minecraft.banner.triangles_top.blue": "Majë trekëndëshe blu",
  "block.minecraft.banner.triangles_top.brown": "Majë trekëndëshe e kaftë",
  "block.minecraft.banner.triangles_top.cyan": "Majë trekëndëshe cian",
  "block.minecraft.banner.triangles_top.gray": "Majë trekëndëshe gri",
  "block.minecraft.banner.triangles_top.green": "Majë trekëndëshe e gjelbër",
  "block.minecraft.banner.triangles_top.light_blue": "Majë trekëndëshe blu e lehtë",
  "block.minecraft.banner.triangles_top.light_gray": "Majë trekëndëshe gri e lehtë",
  "block.minecraft.banner.triangles_top.lime": "Majë trekëndëshe e gjelbër e çelët",
  "block.minecraft.banner.triangles_top.magenta": "Majë trekëndëshe e purpurtë",
  "block.minecraft.banner.triangles_top.orange": "Majë trekëndëshe portokalli",
  "block.minecraft.banner.triangles_top.pink": "Majë trekëndëshe rozë",
  "block.minecraft.banner.triangles_top.purple": "Majë trekëndëshe vjollcë",
  "block.minecraft.banner.triangles_top.red": "Majë trekëndëshe e kuqe",
  "block.minecraft.banner.triangles_top.white": "Majë trekëndëshe e bardhë",
  "block.minecraft.banner.triangles_top.yellow": "Majë trekëndëshe e verdhë",
  "block.minecraft.barrel": "Fuçi",
  "block.minecraft.barrier": "Barrierë",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Fener",
  "block.minecraft.beacon.primary": "Fuqia kryesore",
  "block.minecraft.beacon.secondary": "Fuqia dytësore",
  "block.minecraft.bed.no_sleep": "Mund të flesh vetëm natën ose gjatë stuhive",
  "block.minecraft.bed.not_safe": "Nuk mund të flesh tani, ka përbindësha afër",
  "block.minecraft.bed.obstructed": "Ky shtrat është i penguar",
  "block.minecraft.bed.occupied": "Ky shtrat është i zënë",
  "block.minecraft.bed.too_far_away": "Nuk mund të flesh tani, shtrati është shumë larg",
  "block.minecraft.bedrock": "Shkëmb themelor",
  "block.minecraft.bee_nest": "Fole bletësh",
  "block.minecraft.beehive": "Koshere",
  "block.minecraft.beetroots": "Panxharët",
  "block.minecraft.bell": "Kambanë",
  "block.minecraft.big_dripleaf": "Gjethpikëz i madh",
  "block.minecraft.big_dripleaf_stem": "Kërcell gjethpikëz i madh",
  "block.minecraft.birch_button": "Buton mështeknës",
  "block.minecraft.birch_door": "Derë mështeknës",
  "block.minecraft.birch_fence": "Gardh mështeknës",
  "block.minecraft.birch_fence_gate": "Portë mështeknës",
  "block.minecraft.birch_hanging_sign": "Tabelë mështeknës e varur",
  "block.minecraft.birch_leaves": "Gjethe mështeknës",
  "block.minecraft.birch_log": "Dru mështeknës",
  "block.minecraft.birch_planks": "Dërrasa mështeknës",
  "block.minecraft.birch_pressure_plate": "Pllakë presioni mështeknës",
  "block.minecraft.birch_sapling": "Fidan mështeknës",
  "block.minecraft.birch_shelf": "Raft mështeknës",
  "block.minecraft.birch_sign": "Tabelë mështeknës",
  "block.minecraft.birch_slab": "Rrasë mështeknës",
  "block.minecraft.birch_stairs": "Shkallë mështeknës",
  "block.minecraft.birch_trapdoor": "Kapanxhë mështeknës",
  "block.minecraft.birch_wall_hanging_sign": "Tabelë mështeknës e varur në mur",
  "block.minecraft.birch_wall_sign": "Tabelë mështeknës në mur",
  "block.minecraft.birch_wood": "Trung mështeknës",
  "block.minecraft.black_banner": "Banderolë e zezë",
  "block.minecraft.black_bed": "Shtrat i zi",
  "block.minecraft.black_candle": "Qiri i zi",
  "block.minecraft.black_candle_cake": "Tortë me qirinj të zi",
  "block.minecraft.black_carpet": "Qilim i zi",
  "block.minecraft.black_concrete": "Beton i zi",
  "block.minecraft.black_concrete_powder": "Pluhur betoni të zi",
  "block.minecraft.black_glazed_terracotta": "Terrakotë me xham të zi",
  "block.minecraft.black_shulker_box": "Kutia Shulker-it e zezë",
  "block.minecraft.black_stained_glass": "Qelqi i zi",
  "block.minecraft.black_stained_glass_pane": "Xham i zi",
  "block.minecraft.black_terracotta": "Terrakotë e zezë",
  "block.minecraft.black_wool": "Lesh i zi",
  "block.minecraft.blackstone": "Shkëmb i zi",
  "block.minecraft.blackstone_slab": "Rrasë shkëmbi të zi",
  "block.minecraft.blackstone_stairs": "Shkallë shkëmbi të zi",
  "block.minecraft.blackstone_wall": "Mur shkëmbi të zi",
  "block.minecraft.blast_furnace": "Furrë shpërthyese",
  "block.minecraft.blue_banner": "Banderolë blu",
  "block.minecraft.blue_bed": "Shtrat blu",
  "block.minecraft.blue_candle": "Qiri blu",
  "block.minecraft.blue_candle_cake": "Tortë me qirinj blu",
  "block.minecraft.blue_carpet": "Qilim blu",
  "block.minecraft.blue_concrete": "Betoni blu",
  "block.minecraft.blue_concrete_powder": "Pluhur betoni blu",
  "block.minecraft.blue_glazed_terracotta": "Terrakotë me xham blu",
  "block.minecraft.blue_ice": "Akull blu",
  "block.minecraft.blue_orchid": "Orkide e kaltër",
  "block.minecraft.blue_shulker_box": "Kutia Shulker-it blu",
  "block.minecraft.blue_stained_glass": "Qelqi blu",
  "block.minecraft.blue_stained_glass_pane": "Xham blu",
  "block.minecraft.blue_terracotta": "Terrakotë blu",
  "block.minecraft.blue_wool": "Lesh blu",
  "block.minecraft.bone_block": "Bllok kockash",
  "block.minecraft.bookshelf": "Bibliotekë",
  "block.minecraft.brain_coral": "Koral truri",
  "block.minecraft.brain_coral_block": "Bllok koral truri",
  "block.minecraft.brain_coral_fan": "Kreshtë koral truri",
  "block.minecraft.brain_coral_wall_fan": "Kreshtë koral truri në mur",
  "block.minecraft.brewing_stand": "Distileri",
  "block.minecraft.brick_slab": "Rrasë tullash",
  "block.minecraft.brick_stairs": "Shkallë tullash",
  "block.minecraft.brick_wall": "Mur tullash",
  "block.minecraft.bricks": "Tulla",
  "block.minecraft.brown_banner": "Banderolë e kaftë",
  "block.minecraft.brown_bed": "Shtrat i kaftë",
  "block.minecraft.brown_candle": "Qiri i kaftë",
  "block.minecraft.brown_candle_cake": "Tortë me qirinj të kaftë",
  "block.minecraft.brown_carpet": "Qilim i kaftë",
  "block.minecraft.brown_concrete": "Beton i kaftë",
  "block.minecraft.brown_concrete_powder": "Pluhur betoni të kaftë",
  "block.minecraft.brown_glazed_terracotta": "Terrakotë me xham të kaftë",
  "block.minecraft.brown_mushroom": "Kërpudhë e kaftë",
  "block.minecraft.brown_mushroom_block": "Bllok kërpudhash të kaftë",
  "block.minecraft.brown_shulker_box": "Kutia Shulker-it e kaftë",
  "block.minecraft.brown_stained_glass": "Qelqi i kaftë",
  "block.minecraft.brown_stained_glass_pane": "Xham i kaftë",
  "block.minecraft.brown_terracotta": "Terrakotë e kaftë",
  "block.minecraft.brown_wool": "Lesh i kaftë",
  "block.minecraft.bubble_column": "Kolonë flluskash",
  "block.minecraft.bubble_coral": "Koral flluske",
  "block.minecraft.bubble_coral_block": "Bllok koral flluske",
  "block.minecraft.bubble_coral_fan": "Kreshtë koral flluske",
  "block.minecraft.bubble_coral_wall_fan": "Kreshtë koral flluske në mur",
  "block.minecraft.budding_amethyst": "Bllok ametisti që lulëzon",
  "block.minecraft.bush": "Shkurre",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Lule kaktusi",
  "block.minecraft.cake": "Tortë",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Sensori sculk i kalibruar",
  "block.minecraft.campfire": "Zjarr kampi",
  "block.minecraft.candle": "Qiri",
  "block.minecraft.candle_cake": "Tortë me qirinj",
  "block.minecraft.carrots": "Karota",
  "block.minecraft.cartography_table": "Tavolinë hartëzimi",
  "block.minecraft.carved_pumpkin": "Kungull i skalitur",
  "block.minecraft.cauldron": "Kazan",
  "block.minecraft.cave_air": "Ajri i shpellës",
  "block.minecraft.cave_vines": "Hardhitë e shpellave",
  "block.minecraft.cave_vines_plant": "Bimë e hardhitë të shpellave",
  "block.minecraft.chain": "Zinxhir metalike",
  "block.minecraft.chain_command_block": "Bllok komandues i vazhdueshem",
  "block.minecraft.cherry_button": "Buton qershie",
  "block.minecraft.cherry_door": "Derë qershie",
  "block.minecraft.cherry_fence": "Gardh qershie",
  "block.minecraft.cherry_fence_gate": "Portë qershie",
  "block.minecraft.cherry_hanging_sign": "Tabelë qershie e varur",
  "block.minecraft.cherry_leaves": "Gjethe qershisë",
  "block.minecraft.cherry_log": "Dru qershie",
  "block.minecraft.cherry_planks": "Dërrasa qershie",
  "block.minecraft.cherry_pressure_plate": "Pllakë presioni qershie",
  "block.minecraft.cherry_sapling": "Fidan qershisë",
  "block.minecraft.cherry_shelf": "Raft qershie",
  "block.minecraft.cherry_sign": "Tabelë qershie",
  "block.minecraft.cherry_slab": "Rrasë qershie",
  "block.minecraft.cherry_stairs": "Shkallë qershie",
  "block.minecraft.cherry_trapdoor": "Kapanxhë qershie",
  "block.minecraft.cherry_wall_hanging_sign": "Tabelë qershie e varur në mur",
  "block.minecraft.cherry_wall_sign": "Tabelë qershie në mur",
  "block.minecraft.cherry_wood": "Trung qershie",
  "block.minecraft.chest": "Arkë",
  "block.minecraft.chipped_anvil": "Kudhër e çarë",
  "block.minecraft.chiseled_bookshelf": "Bibliotekë e skalitur",
  "block.minecraft.chiseled_copper": "Bakër i gdhendur",
  "block.minecraft.chiseled_deepslate": "Ardëz e gdhendur e humnerës",
  "block.minecraft.chiseled_nether_bricks": "Tulla të gdhendura të Nether-it",
  "block.minecraft.chiseled_polished_blackstone": "Shkëmb i zi i gdhendur i lëmuar",
  "block.minecraft.chiseled_quartz_block": "Bllok kuarci i gdhendur",
  "block.minecraft.chiseled_red_sandstone": "Gur ranor i gdhendur i kuq",
  "block.minecraft.chiseled_resin_bricks": "Tulla rrëshire të gdhendura",
  "block.minecraft.chiseled_sandstone": "Gur ranor i gdhendur",
  "block.minecraft.chiseled_stone_bricks": "Shkëmb i prerë i gdhendur",
  "block.minecraft.chiseled_tuff": "Shtuf i gdhendur",
  "block.minecraft.chiseled_tuff_bricks": "Shtuf i prerë i gdhendur",
  "block.minecraft.chorus_flower": "Lule korusi",
  "block.minecraft.chorus_plant": "Bimë korusi",
  "block.minecraft.clay": "Argjilë",
  "block.minecraft.closed_eyeblossom": "Lulesyri e mbyllur",
  "block.minecraft.coal_block": "Bllok qymyri",
  "block.minecraft.coal_ore": "Xeheror qymyri",
  "block.minecraft.coarse_dirt": "Dhe i shkretë",
  "block.minecraft.cobbled_deepslate": "Kalldrëm i humnerës",
  "block.minecraft.cobbled_deepslate_slab": "Rrasë kalldrëmi i humnerës",
  "block.minecraft.cobbled_deepslate_stairs": "Shkallë kalldrëmi i humnerës",
  "block.minecraft.cobbled_deepslate_wall": "Mur kalldrëmi i humnerës",
  "block.minecraft.cobblestone": "Gur kalldrëmi",
  "block.minecraft.cobblestone_slab": "Rrasë kalldrëmi",
  "block.minecraft.cobblestone_stairs": "Shkallë kalldrëmi",
  "block.minecraft.cobblestone_wall": "Mur kalldrëmi",
  "block.minecraft.cobweb": "Rrjetë merimange",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Bllok komandues",
  "block.minecraft.comparator": "Krahasues redstoni",
  "block.minecraft.composter": "Kazan kompostimi",
  "block.minecraft.conduit": "Përçues",
  "block.minecraft.copper_bars": "Kangjell bakri",
  "block.minecraft.copper_block": "Bllok bakri",
  "block.minecraft.copper_bulb": "Llambë bakri",
  "block.minecraft.copper_chain": "Zinxhir bakri",
  "block.minecraft.copper_chest": "Arkë bakri",
  "block.minecraft.copper_door": "Derë bakri",
  "block.minecraft.copper_golem_statue": "Statujë e golemit bakri",
  "block.minecraft.copper_grate": "Rrjetë bakri",
  "block.minecraft.copper_lantern": "Fanar bakri",
  "block.minecraft.copper_ore": "Xeheror bakri",
  "block.minecraft.copper_torch": "Pishtar bakri",
  "block.minecraft.copper_trapdoor": "Kapanxhë bakri",
  "block.minecraft.copper_wall_torch": "Pishtar bakri në mur",
  "block.minecraft.cornflower": "Kokoçeli ngjyrë qielli",
  "block.minecraft.cracked_deepslate_bricks": "Ardëz e prerë e çarë e humnerës",
  "block.minecraft.cracked_deepslate_tiles": "Pllakë ardëzi e çarë e humnerës",
  "block.minecraft.cracked_nether_bricks": "Tulla të Nether-it të çara",
  "block.minecraft.cracked_polished_blackstone_bricks": "Shkëmb i zi i prerë i lëmuar i çarë",
  "block.minecraft.cracked_stone_bricks": "Shkëmb i prerë i çarë",
  "block.minecraft.crafter": "Prodhues",
  "block.minecraft.crafting_table": "Tavolinë pune",
  "block.minecraft.creaking_heart": "Zemra e kërcitësit",
  "block.minecraft.creeper_head": "Kokë Creeper-i",
  "block.minecraft.creeper_wall_head": "Kokë Creeper-i në mur",
  "block.minecraft.crimson_button": "Buton i kuqërremtë",
  "block.minecraft.crimson_door": "Derë e kuqërremtë",
  "block.minecraft.crimson_fence": "Gardh i kuqërremtë",
  "block.minecraft.crimson_fence_gate": "Portë e kuqërremtë",
  "block.minecraft.crimson_fungus": "Kërpudhë e kuqërremtë",
  "block.minecraft.crimson_hanging_sign": "Tabelë e kuqërremtë e varur",
  "block.minecraft.crimson_hyphae": "Hife të kuqërremta",
  "block.minecraft.crimson_nylium": "Nilium i kuqërremtë",
  "block.minecraft.crimson_planks": "Dërrasa të kuqërremta",
  "block.minecraft.crimson_pressure_plate": "Pllakë presioni e kuqërremtë",
  "block.minecraft.crimson_roots": "Rrënjët të kuqërremta",
  "block.minecraft.crimson_shelf": "Raft i kuqërremtë",
  "block.minecraft.crimson_sign": "Tabelë e kuqërremtë",
  "block.minecraft.crimson_slab": "Rrasë e kuqërremtë",
  "block.minecraft.crimson_stairs": "Shkallë e kuqërremtë",
  "block.minecraft.crimson_stem": "Kërcell i kuqërremtë",
  "block.minecraft.crimson_trapdoor": "Kapanxhë e kuqërremtë",
  "block.minecraft.crimson_wall_hanging_sign": "Tabelë e kuqërremtë e varur në mur",
  "block.minecraft.crimson_wall_sign": "Tabelë e kuqërremtë në mur",
  "block.minecraft.crying_obsidian": "Obsidian vajtues",
  "block.minecraft.cut_copper": "Bakër i prerë",
  "block.minecraft.cut_copper_slab": "Rrasë bakri e prerë",
  "block.minecraft.cut_copper_stairs": "Shkallë bakri e prerë",
  "block.minecraft.cut_red_sandstone": "Gur ranor i prerë i kuq",
  "block.minecraft.cut_red_sandstone_slab": "Rrasë guri ranor e prerë e kuqe",
  "block.minecraft.cut_sandstone": "Gur ranor i prerë",
  "block.minecraft.cut_sandstone_slab": "Rrasë guri ranor e prerë",
  "block.minecraft.cyan_banner": "Banderolë cian",
  "block.minecraft.cyan_bed": "Shtrat cian",
  "block.minecraft.cyan_candle": "Qiri cian",
  "block.minecraft.cyan_candle_cake": "Tortë me qirinj cian",
  "block.minecraft.cyan_carpet": "Qilim cian",
  "block.minecraft.cyan_concrete": "Betoni cian",
  "block.minecraft.cyan_concrete_powder": "Pluhur betoni cian",
  "block.minecraft.cyan_glazed_terracotta": "Terrakotë me xham cian",
  "block.minecraft.cyan_shulker_box": "Kutia Shulker-it cian",
  "block.minecraft.cyan_stained_glass": "Qelqi cian",
  "block.minecraft.cyan_stained_glass_pane": "Xham cian",
  "block.minecraft.cyan_terracotta": "Terrakotë cian",
  "block.minecraft.cyan_wool": "Lesh cian",
  "block.minecraft.damaged_anvil": "Kudhër e dëmtuar",
  "block.minecraft.dandelion": "Luleradhiqe",
  "block.minecraft.dark_oak_button": "Buton dushkut të errët",
  "block.minecraft.dark_oak_door": "Derë dushkut të errët",
  "block.minecraft.dark_oak_fence": "Gardh dushkut të errët",
  "block.minecraft.dark_oak_fence_gate": "Portë dushkut të errët",
  "block.minecraft.dark_oak_hanging_sign": "Tabelë dushkut të errët e varur",
  "block.minecraft.dark_oak_leaves": "Gjethe dushkut të errët",
  "block.minecraft.dark_oak_log": "Dru dushkut të errët",
  "block.minecraft.dark_oak_planks": "Dërrasa dushkut të errët",
  "block.minecraft.dark_oak_pressure_plate": "Pllakë presioni dushkut të errët",
  "block.minecraft.dark_oak_sapling": "Fidan dushkut të errët",
  "block.minecraft.dark_oak_shelf": "Raft dushkut të errët",
  "block.minecraft.dark_oak_sign": "Tabelë dushkut të errët",
  "block.minecraft.dark_oak_slab": "Rrasë dushkut të errët",
  "block.minecraft.dark_oak_stairs": "Shkallë dushkut të errët",
  "block.minecraft.dark_oak_trapdoor": "Kapanxhë dushkut të errët",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tabelë dushkut të errët e varur në mur",
  "block.minecraft.dark_oak_wall_sign": "Tabelë dushkut të errët në mur",
  "block.minecraft.dark_oak_wood": "Trung dushkut të errët",
  "block.minecraft.dark_prismarine": "Prismarin e errët",
  "block.minecraft.dark_prismarine_slab": "Rrasë prismarineje e errët",
  "block.minecraft.dark_prismarine_stairs": "Shkallë prismarineje të errët",
  "block.minecraft.daylight_detector": "Sensor i dritës",
  "block.minecraft.dead_brain_coral": "Koral truri i vdekur",
  "block.minecraft.dead_brain_coral_block": "Bllok koral truri i vdekur",
  "block.minecraft.dead_brain_coral_fan": "Kreshtë koral truri i vdekur",
  "block.minecraft.dead_brain_coral_wall_fan": "Kreshtë koral truri i vdekur në mur",
  "block.minecraft.dead_bubble_coral": "Koral flluske i vdekur",
  "block.minecraft.dead_bubble_coral_block": "Bllok koral flluske i vdekur",
  "block.minecraft.dead_bubble_coral_fan": "Kreshtë koral flluske i vdekur",
  "block.minecraft.dead_bubble_coral_wall_fan": "Kreshtë koral flluske i vdekur në mur",
  "block.minecraft.dead_bush": "Shkurre e vdekur",
  "block.minecraft.dead_fire_coral": "Koral zjarri i vdekur",
  "block.minecraft.dead_fire_coral_block": "Bllok koral zjarri i vdekur",
  "block.minecraft.dead_fire_coral_fan": "Kreshtë koral zjarri i vdekur",
  "block.minecraft.dead_fire_coral_wall_fan": "Kreshtë koral zjarri i vdekur në mur",
  "block.minecraft.dead_horn_coral": "Koral brirë i vdekur",
  "block.minecraft.dead_horn_coral_block": "Bllok koral brirë i vdekur",
  "block.minecraft.dead_horn_coral_fan": "Kreshtë koral brirë i vdekur",
  "block.minecraft.dead_horn_coral_wall_fan": "Kreshtë koral brirë i vdekur në mur",
  "block.minecraft.dead_tube_coral": "Koral tubi i vdekur",
  "block.minecraft.dead_tube_coral_block": "Bllok koral tubi i vdekur",
  "block.minecraft.dead_tube_coral_fan": "Kreshtë koral tubi i vdekur",
  "block.minecraft.dead_tube_coral_wall_fan": "Kreshtë koral tubi i vdekur në mur",
  "block.minecraft.decorated_pot": "Vazo e zbukuruar",
  "block.minecraft.deepslate": "Ardëz e humnerës",
  "block.minecraft.deepslate_brick_slab": "Rrasë ardëzi e prerë e humnerës",
  "block.minecraft.deepslate_brick_stairs": "Shkallë ardëzi e prerë e humnerës",
  "block.minecraft.deepslate_brick_wall": "Mur ardëzi e prerë e humnerës",
  "block.minecraft.deepslate_bricks": "Ardëz e prerë e humnerës",
  "block.minecraft.deepslate_coal_ore": "Xeheror qymyri i humnerës",
  "block.minecraft.deepslate_copper_ore": "Xeheror bakri i humnerës",
  "block.minecraft.deepslate_diamond_ore": "Xeheror diamanti i humnerës",
  "block.minecraft.deepslate_emerald_ore": "Xeheror smeraldi i humnerës",
  "block.minecraft.deepslate_gold_ore": "Xeheror ari i humnerës",
  "block.minecraft.deepslate_iron_ore": "Xeheror hekuri i humnerës",
  "block.minecraft.deepslate_lapis_ore": "Xeheror lazurit i humnerës",
  "block.minecraft.deepslate_redstone_ore": "Xeheror redstoni i humnerës",
  "block.minecraft.deepslate_tile_slab": "Rrasë pllake ardëzi e humnerës",
  "block.minecraft.deepslate_tile_stairs": "Shkallë pllake ardëzi e humnerës",
  "block.minecraft.deepslate_tile_wall": "Mur pllake ardëzi i humnerës",
  "block.minecraft.deepslate_tiles": "Pllakë ardëzi e humnerës",
  "block.minecraft.detector_rail": "Shina detektues",
  "block.minecraft.diamond_block": "Bllok diamanti",
  "block.minecraft.diamond_ore": "Xeheror diamanti",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Rrasë dioriti",
  "block.minecraft.diorite_stairs": "Shkallë dioriti",
  "block.minecraft.diorite_wall": "Mur dioriti",
  "block.minecraft.dirt": "Dhe",
  "block.minecraft.dirt_path": "Rrugë e dheut",
  "block.minecraft.dispenser": "Shpërndarës",
  "block.minecraft.dragon_egg": "Vezë dragoi",
  "block.minecraft.dragon_head": "Kokë dragoi",
  "block.minecraft.dragon_wall_head": "Kokë dragoi në mur",
  "block.minecraft.dried_ghast": "Ghast i tharë",
  "block.minecraft.dried_kelp_block": "Bllok leshteriku i tharë",
  "block.minecraft.dripstone_block": "Gur gëlqeror",
  "block.minecraft.dropper": "Hedhës",
  "block.minecraft.emerald_block": "Bllok smeraldi",
  "block.minecraft.emerald_ore": "Xeheror smeraldi",
  "block.minecraft.enchanting_table": "Tavolinë përforcimi",
  "block.minecraft.end_gateway": "Portë e End-it",
  "block.minecraft.end_portal": "Portal i End-it",
  "block.minecraft.end_portal_frame": "Kornizë e portalit të End-it",
  "block.minecraft.end_rod": "Shkop i End-it",
  "block.minecraft.end_stone": "Gur i End-it",
  "block.minecraft.end_stone_brick_slab": "Rrasë guri të prerë të End-it",
  "block.minecraft.end_stone_brick_stairs": "Shkallë guri të prerë të End-it",
  "block.minecraft.end_stone_brick_wall": "Mur guri të prerë të End-it",
  "block.minecraft.end_stone_bricks": "Gur i prerë i End-it",
  "block.minecraft.ender_chest": "Arkë e Ender-it",
  "block.minecraft.exposed_chiseled_copper": "Bakër i gdhendur i ekspozuar",
  "block.minecraft.exposed_copper": "Bllok bakri i ekspozuar",
  "block.minecraft.exposed_copper_bars": "Kangjell bakri i ekspozuar",
  "block.minecraft.exposed_copper_bulb": "Llambë bakri e ekspozuar",
  "block.minecraft.exposed_copper_chain": "Zinxhir bakri i ekspozuar",
  "block.minecraft.exposed_copper_chest": "Arkë bakri e ekspozuar",
  "block.minecraft.exposed_copper_door": "Derë bakri e ekspozuar",
  "block.minecraft.exposed_copper_golem_statue": "Statujë e golemit bakri e ekspozuar",
  "block.minecraft.exposed_copper_grate": "Rrjetë bakri e ekspozuar",
  "block.minecraft.exposed_copper_lantern": "Fanar bakri i ekspozuar",
  "block.minecraft.exposed_copper_trapdoor": "Kapanxhë bakri i ekspozuar",
  "block.minecraft.exposed_cut_copper": "Bakër i prerë i ekspozuar",
  "block.minecraft.exposed_cut_copper_slab": "Rrasë bakri e prerë e ekspozuar",
  "block.minecraft.exposed_cut_copper_stairs": "Shkallë bakri e prerë e ekspozuar",
  "block.minecraft.exposed_lightning_rod": "Rrufepritës i ekspozuar",
  "block.minecraft.farmland": "Tokë bujqësore",
  "block.minecraft.fern": "Fier",
  "block.minecraft.fire": "Zjarr",
  "block.minecraft.fire_coral": "Koral zjarri",
  "block.minecraft.fire_coral_block": "Bllok koral zjarri",
  "block.minecraft.fire_coral_fan": "Kreshtë koral zjarri",
  "block.minecraft.fire_coral_wall_fan": "Kreshtë koral zjarri në mur",
  "block.minecraft.firefly_bush": "Shkurre xixëllonjash",
  "block.minecraft.fletching_table": "Tavolinë harkëtari",
  "block.minecraft.flower_pot": "Vazo lulesh",
  "block.minecraft.flowering_azalea": "Azalea e lulëzuar",
  "block.minecraft.flowering_azalea_leaves": "Gjethe azaleje e lulëzuar",
  "block.minecraft.frogspawn": "Veza e bretkosës",
  "block.minecraft.frosted_ice": "Akull i ngrirë",
  "block.minecraft.furnace": "Furrë",
  "block.minecraft.gilded_blackstone": "Shkëmb i zi me ar",
  "block.minecraft.glass": "Qelq",
  "block.minecraft.glass_pane": "Xham",
  "block.minecraft.glow_lichen": "Lichen i ndritshëm",
  "block.minecraft.glowstone": "Gur i ndritshëm",
  "block.minecraft.gold_block": "Bllok ari",
  "block.minecraft.gold_ore": "Xeheror ari",
  "block.minecraft.golden_dandelion": "Luleradhiqe e artë",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Rrasë graniti",
  "block.minecraft.granite_stairs": "Shkallë graniti",
  "block.minecraft.granite_wall": "Mur graniti",
  "block.minecraft.grass": "Bar",
  "block.minecraft.grass_block": "Bllok bari",
  "block.minecraft.gravel": "Zhavorr",
  "block.minecraft.gray_banner": "Banderolë gri",
  "block.minecraft.gray_bed": "Shtrat gri",
  "block.minecraft.gray_candle": "Qiri gri",
  "block.minecraft.gray_candle_cake": "Tortë me qirinj gri",
  "block.minecraft.gray_carpet": "Qilim gri",
  "block.minecraft.gray_concrete": "Betoni gri",
  "block.minecraft.gray_concrete_powder": "Pluhur betoni gri",
  "block.minecraft.gray_glazed_terracotta": "Terrakotë me xham gri",
  "block.minecraft.gray_shulker_box": "Kutia Shulker-it gri",
  "block.minecraft.gray_stained_glass": "Qelqi gri",
  "block.minecraft.gray_stained_glass_pane": "Xham gri",
  "block.minecraft.gray_terracotta": "Terrakotë gri",
  "block.minecraft.gray_wool": "Lesh gri",
  "block.minecraft.green_banner": "Banderolë e gjelbër",
  "block.minecraft.green_bed": "Shtrat i gjelbër",
  "block.minecraft.green_candle": "Qiri i gjelbër",
  "block.minecraft.green_candle_cake": "Tortë me qirinj të gjelbër",
  "block.minecraft.green_carpet": "Qilim i gjelbër",
  "block.minecraft.green_concrete": "Beton i gjelbër",
  "block.minecraft.green_concrete_powder": "Pluhur betoni të gjelbër",
  "block.minecraft.green_glazed_terracotta": "Terrakotë me xham të gjelbër",
  "block.minecraft.green_shulker_box": "Kutia Shulker-it e gjëlber",
  "block.minecraft.green_stained_glass": "Qelqi i gjelbër",
  "block.minecraft.green_stained_glass_pane": "Xham i gjelbër",
  "block.minecraft.green_terracotta": "Terrakotë e gjelbër",
  "block.minecraft.green_wool": "Lesh i gjelbër",
  "block.minecraft.grindstone": "Gur mulliri",
  "block.minecraft.hanging_roots": "Rrënjët e varura",
  "block.minecraft.hay_block": "Balë kashte",
  "block.minecraft.heavy_core": "Bërthamë e rëndë",
  "block.minecraft.heavy_weighted_pressure_plate": "Pllakë presioni me peshë të rëndë",
  "block.minecraft.honey_block": "Bllok mjalti",
  "block.minecraft.honeycomb_block": "Bllok hualli",
  "block.minecraft.hopper": "Hinkë",
  "block.minecraft.horn_coral": "Koral brirë",
  "block.minecraft.horn_coral_block": "Bllok koral brirë",
  "block.minecraft.horn_coral_fan": "Kreshtë koral brirë",
  "block.minecraft.horn_coral_wall_fan": "Kreshtë koral brirë në mur",
  "block.minecraft.ice": "Akull",
  "block.minecraft.infested_chiseled_stone_bricks": "Shkëmb i prerë i gdhendur i pushtuar",
  "block.minecraft.infested_cobblestone": "Gur kalldrëmi i pushtuar",
  "block.minecraft.infested_cracked_stone_bricks": "Shkëmb i prerë i çarë i pushtuar",
  "block.minecraft.infested_deepslate": "Ardëz e humnerës e pushtuar",
  "block.minecraft.infested_mossy_stone_bricks": "Shkëmb i prerë me myshk i pushtuar",
  "block.minecraft.infested_stone": "Shkëmb i pushtuar",
  "block.minecraft.infested_stone_bricks": "Shkëmb i prerë i pushtuar",
  "block.minecraft.iron_bars": "Kangjell hekuri",
  "block.minecraft.iron_block": "Bllok hekuri",
  "block.minecraft.iron_chain": "Zinxhir metalike",
  "block.minecraft.iron_door": "Derë hekuri",
  "block.minecraft.iron_ore": "Xeheror hekuri",
  "block.minecraft.iron_trapdoor": "Kapanxhë hekuri",
  "block.minecraft.jack_o_lantern": "Kungull ndriçues",
  "block.minecraft.jigsaw": "Bllok xhigsou",
  "block.minecraft.jukebox": "Gramafon",
  "block.minecraft.jungle_button": "Buton xhunglës",
  "block.minecraft.jungle_door": "Derë xhunglës",
  "block.minecraft.jungle_fence": "Gardh xhunglës",
  "block.minecraft.jungle_fence_gate": "Portë xhunglës",
  "block.minecraft.jungle_hanging_sign": "Tabelë xhunglës e varur",
  "block.minecraft.jungle_leaves": "Gjethe xhunglës",
  "block.minecraft.jungle_log": "Dru xhunglës",
  "block.minecraft.jungle_planks": "Dërrasa xhunglës",
  "block.minecraft.jungle_pressure_plate": "Pllakë presioni xhunglës",
  "block.minecraft.jungle_sapling": "Fidan xhunglës",
  "block.minecraft.jungle_shelf": "Raft xhunglës",
  "block.minecraft.jungle_sign": "Tabelë xhunglës",
  "block.minecraft.jungle_slab": "Rrasë xhunglës",
  "block.minecraft.jungle_stairs": "Shkallë xhunglës",
  "block.minecraft.jungle_trapdoor": "Kapanxhë xhunglës",
  "block.minecraft.jungle_wall_hanging_sign": "Tabelë xhunglës e varur në mur",
  "block.minecraft.jungle_wall_sign": "Tabelë xhunglës në mur",
  "block.minecraft.jungle_wood": "Trung xhunglës",
  "block.minecraft.kelp": "Leshterik",
  "block.minecraft.kelp_plant": "Bimë leshteriku",
  "block.minecraft.ladder": "Shkallë",
  "block.minecraft.lantern": "Fanar",
  "block.minecraft.lapis_block": "Bllok lazurit",
  "block.minecraft.lapis_ore": "Xeheror lazurit",
  "block.minecraft.large_amethyst_bud": "Kristal i madh ametisti",
  "block.minecraft.large_fern": "Fier i madh",
  "block.minecraft.lava": "Llavë",
  "block.minecraft.lava_cauldron": "Kazan me llavë",
  "block.minecraft.leaf_litter": "Grumbull gjethesh",
  "block.minecraft.lectern": "Pult",
  "block.minecraft.lever": "Levë",
  "block.minecraft.light": "Dritë",
  "block.minecraft.light_blue_banner": "Banderolë blu e lehtë",
  "block.minecraft.light_blue_bed": "Shtrat blu e lehtë",
  "block.minecraft.light_blue_candle": "Qiri blu e lehtë",
  "block.minecraft.light_blue_candle_cake": "Tortë me qirinj blu të lehtë",
  "block.minecraft.light_blue_carpet": "Qilim blu e lehtë",
  "block.minecraft.light_blue_concrete": "Betoni blu e lehtë",
  "block.minecraft.light_blue_concrete_powder": "Pluhur betoni blu të lehtë",
  "block.minecraft.light_blue_glazed_terracotta": "Terrakotë me xham blu e lehtë",
  "block.minecraft.light_blue_shulker_box": "Kutia Shulker-it blu e lehtë",
  "block.minecraft.light_blue_stained_glass": "Qelqi blu i lehtë",
  "block.minecraft.light_blue_stained_glass_pane": "Xham blu i lehtë",
  "block.minecraft.light_blue_terracotta": "Terrakotë blu e lehtë",
  "block.minecraft.light_blue_wool": "Lesh blu e lehtë",
  "block.minecraft.light_gray_banner": "Banderolë gri e lehtë",
  "block.minecraft.light_gray_bed": "Shtrat gri e lehtë",
  "block.minecraft.light_gray_candle": "Qiri gri e lehtë",
  "block.minecraft.light_gray_candle_cake": "Tortë me qirinj gri të lehtë",
  "block.minecraft.light_gray_carpet": "Qilim gri e lehtë",
  "block.minecraft.light_gray_concrete": "Betoni gri e lehtë",
  "block.minecraft.light_gray_concrete_powder": "Pluhur betoni gri të lehtë",
  "block.minecraft.light_gray_glazed_terracotta": "Terrakotë me xham gri e lehtë",
  "block.minecraft.light_gray_shulker_box": "Kutia Shulker-it gri e lehtë",
  "block.minecraft.light_gray_stained_glass": "Qelqi gri i lehtë",
  "block.minecraft.light_gray_stained_glass_pane": "Xham gri i lehtë",
  "block.minecraft.light_gray_terracotta": "Terrakotë gri e lehtë",
  "block.minecraft.light_gray_wool": "Lesh gri i lehte",
  "block.minecraft.light_weighted_pressure_plate": "Pllakë presioni me peshë të lehtë",
  "block.minecraft.lightning_rod": "Rrufepritës",
  "block.minecraft.lilac": "Jargavan",
  "block.minecraft.lily_of_the_valley": "Zambakut të luginës",
  "block.minecraft.lily_pad": "Zambak uji",
  "block.minecraft.lime_banner": "Banderolë e gjelbër e çelët",
  "block.minecraft.lime_bed": "Shtrat i gjelbër e çelët",
  "block.minecraft.lime_candle": "Qiri i gjelbër e çelët",
  "block.minecraft.lime_candle_cake": "Tortë me qirinj të gjelbër e çelët",
  "block.minecraft.lime_carpet": "Qilim i gjelbër e çelët",
  "block.minecraft.lime_concrete": "Beton i gjelbër e çelët",
  "block.minecraft.lime_concrete_powder": "Pluhur betoni të gjelbër të çelët",
  "block.minecraft.lime_glazed_terracotta": "Terrakotë me xham të gjelbër e çelët",
  "block.minecraft.lime_shulker_box": "Kutia Shulker-it gjelbër e qelt",
  "block.minecraft.lime_stained_glass": "Qelqi i gjelbër i çelët",
  "block.minecraft.lime_stained_glass_pane": "Xham i gjelbër i çelët",
  "block.minecraft.lime_terracotta": "Terrakotë e gjelbër e çelët",
  "block.minecraft.lime_wool": "Lesh i gjelbër e çelët",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Tezgjah",
  "block.minecraft.magenta_banner": "Banderolë e purpurtë",
  "block.minecraft.magenta_bed": "Shtrat i purpurtë",
  "block.minecraft.magenta_candle": "Qiri i purpurtë",
  "block.minecraft.magenta_candle_cake": "Tortë me qirinj të purpurtë",
  "block.minecraft.magenta_carpet": "Qilim i purpurtë",
  "block.minecraft.magenta_concrete": "Beton i purpurtë",
  "block.minecraft.magenta_concrete_powder": "Pluhur betoni të purpurtë",
  "block.minecraft.magenta_glazed_terracotta": "Terrakotë me xham të purpurtë",
  "block.minecraft.magenta_shulker_box": "Kutia Shulker-it e purpurtë",
  "block.minecraft.magenta_stained_glass": "Qelqi i purpurtë",
  "block.minecraft.magenta_stained_glass_pane": "Xham i purpurtë",
  "block.minecraft.magenta_terracotta": "Terrakotë e purpurtë",
  "block.minecraft.magenta_wool": "Lesh i purpurtë",
  "block.minecraft.magma_block": "Bllok magmë",
  "block.minecraft.mangrove_button": "Buton mangrovës",
  "block.minecraft.mangrove_door": "Derë mangrovës",
  "block.minecraft.mangrove_fence": "Gardh mangrovës",
  "block.minecraft.mangrove_fence_gate": "Portë mangrovës",
  "block.minecraft.mangrove_hanging_sign": "Tabelë mangrovës e varur",
  "block.minecraft.mangrove_leaves": "Gjethe mangrovës",
  "block.minecraft.mangrove_log": "Dru mangrovës",
  "block.minecraft.mangrove_planks": "Dërrasa mangrovës",
  "block.minecraft.mangrove_pressure_plate": "Pllakë presioni mangrovës",
  "block.minecraft.mangrove_propagule": "Filiz mangrovës",
  "block.minecraft.mangrove_roots": "Rrënjët mangrovës",
  "block.minecraft.mangrove_shelf": "Raft mangrovës",
  "block.minecraft.mangrove_sign": "Tabelë mangrovës",
  "block.minecraft.mangrove_slab": "Rrasë mangrovës",
  "block.minecraft.mangrove_stairs": "Shkallë mangrovës",
  "block.minecraft.mangrove_trapdoor": "Kapanxhë mangrovës",
  "block.minecraft.mangrove_wall_hanging_sign": "Tabelë mangrovës e varur në mur",
  "block.minecraft.mangrove_wall_sign": "Tabelë mangrovës në mur",
  "block.minecraft.mangrove_wood": "Trung mangrovës",
  "block.minecraft.medium_amethyst_bud": "Kristal i mesëm ametisti",
  "block.minecraft.melon": "Shalqi",
  "block.minecraft.melon_stem": "Kërcell i shalqirit",
  "block.minecraft.moss_block": "Bllok myshkut",
  "block.minecraft.moss_carpet": "Qilim i myshkut",
  "block.minecraft.mossy_cobblestone": "Gur kalldrëmi me myshk",
  "block.minecraft.mossy_cobblestone_slab": "Rrasë kalldrëmi me myshk",
  "block.minecraft.mossy_cobblestone_stairs": "Shkallë kalldrëmi me myshk",
  "block.minecraft.mossy_cobblestone_wall": "Mur kalldrëmi me myshk",
  "block.minecraft.mossy_stone_brick_slab": "Rrasë shkëmbi të prerë me myshk",
  "block.minecraft.mossy_stone_brick_stairs": "Shkallë shkëmbi të prerë me myshk",
  "block.minecraft.mossy_stone_brick_wall": "Mur shkëmbi të prerë me myshk",
  "block.minecraft.mossy_stone_bricks": "Shkëmb i prerë me myshk",
  "block.minecraft.moving_piston": "Piston në lëvizje",
  "block.minecraft.mud": "Baltë",
  "block.minecraft.mud_brick_slab": "Rrasë tullash deltine",
  "block.minecraft.mud_brick_stairs": "Shkallë tullash deltine",
  "block.minecraft.mud_brick_wall": "Mur tullash deltine",
  "block.minecraft.mud_bricks": "Tulla deltine",
  "block.minecraft.muddy_mangrove_roots": "Rrënjët mangrovës me baltë",
  "block.minecraft.mushroom_stem": "Kërcell i kërpudhës",
  "block.minecraft.mycelium": "Miceli",
  "block.minecraft.nether_brick_fence": "Gardh tullash të Nether-it",
  "block.minecraft.nether_brick_slab": "Rrasë tullash të Nether-it",
  "block.minecraft.nether_brick_stairs": "Shkallë tullash të Nether-it",
  "block.minecraft.nether_brick_wall": "Mur tullash të Nether-it",
  "block.minecraft.nether_bricks": "Tulla të Nether-it",
  "block.minecraft.nether_gold_ore": "Xeheror ari i Nether-it",
  "block.minecraft.nether_portal": "Portal i Nether-it",
  "block.minecraft.nether_quartz_ore": "Xeheror kuarci i Nether-it",
  "block.minecraft.nether_sprouts": "Bar i Nether-it",
  "block.minecraft.nether_wart": "Lythat e Nether-it",
  "block.minecraft.nether_wart_block": "Bllok lythave të Nether-it",
  "block.minecraft.netherite_block": "Bllok Netheriti",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bllok muzikor",
  "block.minecraft.oak_button": "Buton dushkut",
  "block.minecraft.oak_door": "Derë dushkut",
  "block.minecraft.oak_fence": "Gardh dushkut",
  "block.minecraft.oak_fence_gate": "Portë dushkut",
  "block.minecraft.oak_hanging_sign": "Tabelë dushkut e varur",
  "block.minecraft.oak_leaves": "Gjethe dushkut",
  "block.minecraft.oak_log": "Dru dushkut",
  "block.minecraft.oak_planks": "Dërrasa dushkut",
  "block.minecraft.oak_pressure_plate": "Pllakë presioni dushkut",
  "block.minecraft.oak_sapling": "Fidan dushkut",
  "block.minecraft.oak_shelf": "Raft dushkut",
  "block.minecraft.oak_sign": "Tabelë dushkut",
  "block.minecraft.oak_slab": "Rrasë dushkut",
  "block.minecraft.oak_stairs": "Shkallë dushkut",
  "block.minecraft.oak_trapdoor": "Kapanxhë dushkut",
  "block.minecraft.oak_wall_hanging_sign": "Tabelë dushkut e varur në mur",
  "block.minecraft.oak_wall_sign": "Tabelë dushkut në mur",
  "block.minecraft.oak_wood": "Trung dushkut",
  "block.minecraft.observer": "Vëzhgues",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Dritkosa okër",
  "block.minecraft.ominous_banner": "Banderolë e fatkeqësisë",
  "block.minecraft.open_eyeblossom": "Lulesyri i hapur",
  "block.minecraft.orange_banner": "Banderolë portokalli",
  "block.minecraft.orange_bed": "Shtrat portokalli",
  "block.minecraft.orange_candle": "Qiri i portokalltë",
  "block.minecraft.orange_candle_cake": "Tortë me qirinj portokalli",
  "block.minecraft.orange_carpet": "Qilim i portokalltë",
  "block.minecraft.orange_concrete": "Betoni i portokalltë",
  "block.minecraft.orange_concrete_powder": "Pluhur betoni i portokalltë",
  "block.minecraft.orange_glazed_terracotta": "Terrakotë me xham të portokalltë",
  "block.minecraft.orange_shulker_box": "Kutia Shulker-it i portokalltë",
  "block.minecraft.orange_stained_glass": "Qelqi i portokalltë",
  "block.minecraft.orange_stained_glass_pane": "Xham i portokalltë",
  "block.minecraft.orange_terracotta": "Terrakotë e portokalltë",
  "block.minecraft.orange_tulip": "Tulipan i portokalltë",
  "block.minecraft.orange_wool": "Lesh i portokalltë",
  "block.minecraft.oxeye_daisy": "Margaritë",
  "block.minecraft.oxidized_chiseled_copper": "Bakër i gdhendur i oksiduar",
  "block.minecraft.oxidized_copper": "Bllok bakri i oksiduar",
  "block.minecraft.oxidized_copper_bars": "Kangjell bakri i oksiduar",
  "block.minecraft.oxidized_copper_bulb": "Llambë bakri e oksiduar",
  "block.minecraft.oxidized_copper_chain": "Zinxhir bakri i oksiduar",
  "block.minecraft.oxidized_copper_chest": "Arkë bakri e oksiduar",
  "block.minecraft.oxidized_copper_door": "Derë bakri e oksiduar",
  "block.minecraft.oxidized_copper_golem_statue": "Statujë e golemit bakri e oksiduar",
  "block.minecraft.oxidized_copper_grate": "Rrjetë bakri e oksiduar",
  "block.minecraft.oxidized_copper_lantern": "Fanar bakri i oksiduar",
  "block.minecraft.oxidized_copper_trapdoor": "Kapanxhë bakri i oksiduar",
  "block.minecraft.oxidized_cut_copper": "Bakër i prerë i oksiduar",
  "block.minecraft.oxidized_cut_copper_slab": "Rrasë bakri e prerë e oksiduar",
  "block.minecraft.oxidized_cut_copper_stairs": "Shkallë bakri e prerë e oksiduar",
  "block.minecraft.oxidized_lightning_rod": "Rrufepritës i oksiduar",
  "block.minecraft.packed_ice": "Akull kompakte",
  "block.minecraft.packed_mud": "Deltinë",
  "block.minecraft.pale_hanging_moss": "Myshk i varur i zbehtë",
  "block.minecraft.pale_moss_block": "Bllok myshku të zbehtë",
  "block.minecraft.pale_moss_carpet": "Qilim i myshkut të zbehtë",
  "block.minecraft.pale_oak_button": "Buton dushkut të zbehtë",
  "block.minecraft.pale_oak_door": "Derë dushkut të zbehtë",
  "block.minecraft.pale_oak_fence": "Gardh dushkut të zbehtë",
  "block.minecraft.pale_oak_fence_gate": "Portë dushkut të zbehtë",
  "block.minecraft.pale_oak_hanging_sign": "Tabelë dushkut të zbehtë e varur",
  "block.minecraft.pale_oak_leaves": "Gjethe dushkut të zbehtë",
  "block.minecraft.pale_oak_log": "Dru dushkut të zbehtë",
  "block.minecraft.pale_oak_planks": "Dërrasa dushkut të zbehtë",
  "block.minecraft.pale_oak_pressure_plate": "Pllakë presioni dushkut të zbehtë",
  "block.minecraft.pale_oak_sapling": "Fidan dushkut të zbehtë",
  "block.minecraft.pale_oak_shelf": "Raft dushkut të zbehtë",
  "block.minecraft.pale_oak_sign": "Tabelë dushkut të zbehtë",
  "block.minecraft.pale_oak_slab": "Rrasë dushkut të zbehtë",
  "block.minecraft.pale_oak_stairs": "Shkallë dushkut të zbehtë",
  "block.minecraft.pale_oak_trapdoor": "Kapanxhë dushkut të zbehtë",
  "block.minecraft.pale_oak_wall_hanging_sign": "Tabelë dushkut të zbehtë e varur në mur",
  "block.minecraft.pale_oak_wall_sign": "Tabelë dushkut të zbehtë në mur",
  "block.minecraft.pale_oak_wood": "Trung dushkut të zbehtë",
  "block.minecraft.pearlescent_froglight": "Dritkosa perlës",
  "block.minecraft.peony": "Bozhure",
  "block.minecraft.petrified_oak_slab": "Rrasë dushkut e ngurtësuar",
  "block.minecraft.piglin_head": "Kokë Piglin-i",
  "block.minecraft.piglin_wall_head": "Kokë Piglin-i në mur",
  "block.minecraft.pink_banner": "Banderolë rozë",
  "block.minecraft.pink_bed": "Shtrat rozë",
  "block.minecraft.pink_candle": "Qiri rozë",
  "block.minecraft.pink_candle_cake": "Tortë me qirinj rozë",
  "block.minecraft.pink_carpet": "Qilim rozë",
  "block.minecraft.pink_concrete": "Betoni rozë",
  "block.minecraft.pink_concrete_powder": "Pluhur betoni rozë",
  "block.minecraft.pink_glazed_terracotta": "Terrakotë me xham rozë",
  "block.minecraft.pink_petals": "Petat rozë",
  "block.minecraft.pink_shulker_box": "Kutia Shulker-it rozë",
  "block.minecraft.pink_stained_glass": "Qelqi rozë",
  "block.minecraft.pink_stained_glass_pane": "Xham rozë",
  "block.minecraft.pink_terracotta": "Terrakotë rozë",
  "block.minecraft.pink_tulip": "Tulipan rozë",
  "block.minecraft.pink_wool": "Lesh rozë",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Kokë pistoni",
  "block.minecraft.pitcher_crop": "Bimë sarraceni",
  "block.minecraft.pitcher_plant": "Shtambë tropikale",
  "block.minecraft.player_head": "Kokë lojtari",
  "block.minecraft.player_head.named": "Koka e %s",
  "block.minecraft.player_wall_head": "Kokë lojtari në mur",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Gur gëlqeror i mprehtë",
  "block.minecraft.polished_andesite": "Andezit i lëmuar",
  "block.minecraft.polished_andesite_slab": "Rrasë andeziti e lëmuar",
  "block.minecraft.polished_andesite_stairs": "Shkallë andeziti të lëmuar",
  "block.minecraft.polished_basalt": "Bazalt i lëmuar",
  "block.minecraft.polished_blackstone": "Shkëmb i zi i lëmuar",
  "block.minecraft.polished_blackstone_brick_slab": "Rrasë shkëmbi të zi të prerë të lëmuar",
  "block.minecraft.polished_blackstone_brick_stairs": "Shkallë shkëmbi të zi të prerë të lëmuar",
  "block.minecraft.polished_blackstone_brick_wall": "Mur shkëmbi të zi të prerë të lëmuar",
  "block.minecraft.polished_blackstone_bricks": "Shkëmb i zi i prerë i lëmuar",
  "block.minecraft.polished_blackstone_button": "Buton shkëmbi të zi të lëmuar",
  "block.minecraft.polished_blackstone_pressure_plate": "Pllakë presioni shkëmbi të zi të lëmuar",
  "block.minecraft.polished_blackstone_slab": "Rrasë shkëmbi të zi të lëmuar",
  "block.minecraft.polished_blackstone_stairs": "Shkallë shkëmbi të zi të lëmuar",
  "block.minecraft.polished_blackstone_wall": "Mur shkëmbi të zi të lëmuar",
  "block.minecraft.polished_deepslate": "Ardëz e lëmuar e humnerës",
  "block.minecraft.polished_deepslate_slab": "Rrasë ardëzi e lëmuar e humnerës",
  "block.minecraft.polished_deepslate_stairs": "Shkallë ardëzi e lëmuar e humnerës",
  "block.minecraft.polished_deepslate_wall": "Mur ardëzi e lëmuar e humnerës",
  "block.minecraft.polished_diorite": "Diorit i lëmuar",
  "block.minecraft.polished_diorite_slab": "Rrasë dioriti e lëmuar",
  "block.minecraft.polished_diorite_stairs": "Shkallë dioriti të lëmuar",
  "block.minecraft.polished_granite": "Granit i lëmuar",
  "block.minecraft.polished_granite_slab": "Rrasë graniti e lëmuar",
  "block.minecraft.polished_granite_stairs": "Shkallë graniti të lëmuar",
  "block.minecraft.polished_tuff": "Shtuf i lëmuar",
  "block.minecraft.polished_tuff_slab": "Rrasë shtufi e lëmuar",
  "block.minecraft.polished_tuff_stairs": "Shkallë shtufi të lëmuar",
  "block.minecraft.polished_tuff_wall": "Mur shtufi të lëmuar",
  "block.minecraft.poppy": "Lulekuqe",
  "block.minecraft.potatoes": "Patate",
  "block.minecraft.potted_acacia_sapling": "Fidan akacisës në vazo",
  "block.minecraft.potted_allium": "Allium në vazo",
  "block.minecraft.potted_azalea_bush": "Azalea në vazo",
  "block.minecraft.potted_azure_bluet": "Hjustoni blu në vazo",
  "block.minecraft.potted_bamboo": "Bambu në vazo",
  "block.minecraft.potted_birch_sapling": "Fidan mështeknës në vazo",
  "block.minecraft.potted_blue_orchid": "Orkide e kaltër në vazo",
  "block.minecraft.potted_brown_mushroom": "Kërpudhë e kaftë në vazo",
  "block.minecraft.potted_cactus": "Kaktus në vazo",
  "block.minecraft.potted_cherry_sapling": "Fidan qershisë në vazo",
  "block.minecraft.potted_closed_eyeblossom": "Lulesyri e mbyllur në vazo",
  "block.minecraft.potted_cornflower": "Kokoçeli ngjyrë qielli në vazo",
  "block.minecraft.potted_crimson_fungus": "Kërpudhë e kuqërremtë në vazo",
  "block.minecraft.potted_crimson_roots": "Rrënjët të kuqërremta në vazo",
  "block.minecraft.potted_dandelion": "Luleradhiqe në vazo",
  "block.minecraft.potted_dark_oak_sapling": "Fidan dushkut të errët në vazo",
  "block.minecraft.potted_dead_bush": "Shkurre e vdekur në vazo",
  "block.minecraft.potted_fern": "Fier në vazo",
  "block.minecraft.potted_flowering_azalea_bush": "Azalea e lulëzuar në vazo",
  "block.minecraft.potted_golden_dandelion": "Luleradhiqe e artë në vazo",
  "block.minecraft.potted_jungle_sapling": "Fidan xhunglës në vazo",
  "block.minecraft.potted_lily_of_the_valley": "Zambakut të luginës në vazo",
  "block.minecraft.potted_mangrove_propagule": "Filiz mangrovës në vazo",
  "block.minecraft.potted_oak_sapling": "Fidan dushkut në vazo",
  "block.minecraft.potted_open_eyeblossom": "Lulesyri e hapur në vazo",
  "block.minecraft.potted_orange_tulip": "Tulipan portokalli në vazo",
  "block.minecraft.potted_oxeye_daisy": "Margaritë në vazo",
  "block.minecraft.potted_pale_oak_sapling": "Fidan dushkut të zbehtë në vazo",
  "block.minecraft.potted_pink_tulip": "Tulipan rozë në vazo",
  "block.minecraft.potted_poppy": "Lulekuqe në vazo",
  "block.minecraft.potted_red_mushroom": "Kërpudhë e kuqe në vazo",
  "block.minecraft.potted_red_tulip": "Tulipan i kuq në vazo",
  "block.minecraft.potted_spruce_sapling": "Fidan bredhit në vazo",
  "block.minecraft.potted_torchflower": "Lulepishtari në vazo",
  "block.minecraft.potted_warped_fungus": "Kërpudhë e deformuar në vazo",
  "block.minecraft.potted_warped_roots": "Rrënjët të çuditshme në vazo",
  "block.minecraft.potted_white_tulip": "Tulipan i bardhë në vazo",
  "block.minecraft.potted_wither_rose": "Trëndafil i Wither-it në vazo",
  "block.minecraft.powder_snow": "Pluhur bore",
  "block.minecraft.powder_snow_cauldron": "Kazan me pluhur bore",
  "block.minecraft.powered_rail": "Shina shtytëse",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Rrasë tullash prismarineje",
  "block.minecraft.prismarine_brick_stairs": "Shkallë tullash prismarineje",
  "block.minecraft.prismarine_bricks": "Tulla prismarineje",
  "block.minecraft.prismarine_slab": "Rrasë prismarineje",
  "block.minecraft.prismarine_stairs": "Shkallë prismarineje",
  "block.minecraft.prismarine_wall": "Mur prismarineje",
  "block.minecraft.pumpkin": "Kungull",
  "block.minecraft.pumpkin_stem": "Kërcell i kungullit",
  "block.minecraft.purple_banner": "Banderolë vjollcë",
  "block.minecraft.purple_bed": "Shtrat vjollcë",
  "block.minecraft.purple_candle": "Qiri vjollcë",
  "block.minecraft.purple_candle_cake": "Tortë me qirinj vjollcë",
  "block.minecraft.purple_carpet": "Qilim vjollcë",
  "block.minecraft.purple_concrete": "Betoni vjollcë",
  "block.minecraft.purple_concrete_powder": "Pluhur betoni vjollcë",
  "block.minecraft.purple_glazed_terracotta": "Terrakotë me xham vjollcë",
  "block.minecraft.purple_shulker_box": "Kutia Shulker-it vjollcë",
  "block.minecraft.purple_stained_glass": "Qelqi vjollcë",
  "block.minecraft.purple_stained_glass_pane": "Xham vjollcë",
  "block.minecraft.purple_terracotta": "Terrakotë vjollcë",
  "block.minecraft.purple_wool": "Lesh vjollcë",
  "block.minecraft.purpur_block": "Bllok purpuri",
  "block.minecraft.purpur_pillar": "Shtyllë purpuri",
  "block.minecraft.purpur_slab": "Rrasë purpuri",
  "block.minecraft.purpur_stairs": "Shkallë purpuri",
  "block.minecraft.quartz_block": "Bllok kuarci",
  "block.minecraft.quartz_bricks": "Tulla kuarci",
  "block.minecraft.quartz_pillar": "Shtyllë kuarci",
  "block.minecraft.quartz_slab": "Rrasë kuarci",
  "block.minecraft.quartz_stairs": "Shkallë kuarci",
  "block.minecraft.rail": "Shina",
  "block.minecraft.raw_copper_block": "Bllok bakri i papërpunuar",
  "block.minecraft.raw_gold_block": "Bllok ari i papërpunuar",
  "block.minecraft.raw_iron_block": "Bllok hekuri i papërpunuar",
  "block.minecraft.red_banner": "Banderolë e kuqe",
  "block.minecraft.red_bed": "Shtrat i kuq",
  "block.minecraft.red_candle": "Qiri i kuq",
  "block.minecraft.red_candle_cake": "Tortë me qirinj të kuq",
  "block.minecraft.red_carpet": "Qilim i kuq",
  "block.minecraft.red_concrete": "Beton i kuq",
  "block.minecraft.red_concrete_powder": "Pluhur betoni të kuq",
  "block.minecraft.red_glazed_terracotta": "Terrakotë me xham të kuqe",
  "block.minecraft.red_mushroom": "Kërpudhë e kuqe",
  "block.minecraft.red_mushroom_block": "Bllok kërpudhash të kuqe",
  "block.minecraft.red_nether_brick_slab": "Rrasë tullash të kuqe të Nether-it",
  "block.minecraft.red_nether_brick_stairs": "Shkallë tullash të kuqe të Nether-it",
  "block.minecraft.red_nether_brick_wall": "Mur tullash të kuqe të Nether-it",
  "block.minecraft.red_nether_bricks": "Tulla të kuqe të Nether-it",
  "block.minecraft.red_sand": "Rërë e kuqe",
  "block.minecraft.red_sandstone": "Gur ranor i kuq",
  "block.minecraft.red_sandstone_slab": "Rrasë guri ranor e kuqe",
  "block.minecraft.red_sandstone_stairs": "Shkallë guri ranor e kuqe",
  "block.minecraft.red_sandstone_wall": "Mur guri ranor i kuq",
  "block.minecraft.red_shulker_box": "Kutia Shulker-it e kuqe",
  "block.minecraft.red_stained_glass": "Qelqi i kuq",
  "block.minecraft.red_stained_glass_pane": "Xham i kuq",
  "block.minecraft.red_terracotta": "Terrakotë e kuqe",
  "block.minecraft.red_tulip": "Tulipan i kuq",
  "block.minecraft.red_wool": "Lesh i kuq",
  "block.minecraft.redstone_block": "Bllok redstoni",
  "block.minecraft.redstone_lamp": "Llambë redstoni",
  "block.minecraft.redstone_ore": "Xeheror redstoni",
  "block.minecraft.redstone_torch": "Pishtar redstoni",
  "block.minecraft.redstone_wall_torch": "Pishtar redstoni në mur",
  "block.minecraft.redstone_wire": "Kabëll redstoni",
  "block.minecraft.reinforced_deepslate": "Ardëz e përforcuar e humnerës",
  "block.minecraft.repeater": "Përsëritës redstoni",
  "block.minecraft.repeating_command_block": "Bllok komandues përsëritës",
  "block.minecraft.resin_block": "Bllok rrëshire",
  "block.minecraft.resin_brick_slab": "Rrasë tullash rrëshire",
  "block.minecraft.resin_brick_stairs": "Shkallë tullash rrëshire",
  "block.minecraft.resin_brick_wall": "Mur tullash rrëshire",
  "block.minecraft.resin_bricks": "Tulla rrëshire",
  "block.minecraft.resin_clump": "Gungë rrëshire",
  "block.minecraft.respawn_anchor": "Spirancë e ringjalljes",
  "block.minecraft.rooted_dirt": "Dhe me rrënjë",
  "block.minecraft.rose_bush": "Shkurre trëndafili",
  "block.minecraft.sand": "Rërë",
  "block.minecraft.sandstone": "Gur ranor",
  "block.minecraft.sandstone_slab": "Rrasë guri ranor",
  "block.minecraft.sandstone_stairs": "Shkallë guri ranor",
  "block.minecraft.sandstone_wall": "Mur guri ranor",
  "block.minecraft.scaffolding": "Skeleri",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Katalizator sculk",
  "block.minecraft.sculk_sensor": "Sensori sculk",
  "block.minecraft.sculk_shrieker": "Sculk ulëritës",
  "block.minecraft.sculk_vein": "Vena sculk-i",
  "block.minecraft.sea_lantern": "Fanar deti",
  "block.minecraft.sea_pickle": "Turshi deti",
  "block.minecraft.seagrass": "Bar deti",
  "block.minecraft.set_spawn": "Pika e ringjalljes u vendos",
  "block.minecraft.short_dry_grass": "Bar i shkurtër i thatë",
  "block.minecraft.short_grass": "Bar i shkurtër",
  "block.minecraft.shroomlight": "Kërpudritë",
  "block.minecraft.shulker_box": "Kutia Shulker-it",
  "block.minecraft.skeleton_skull": "Kafkë skeleti",
  "block.minecraft.skeleton_wall_skull": "Kafkë skeleti në mur",
  "block.minecraft.slime_block": "Bllok sllajmi",
  "block.minecraft.small_amethyst_bud": "Kristal i vogël ametisti",
  "block.minecraft.small_dripleaf": "Gjethpikëz i vogël",
  "block.minecraft.smithing_table": "Tavolinë farkëtimi",
  "block.minecraft.smoker": "Tymtore",
  "block.minecraft.smooth_basalt": "Bazalt i lëmuar",
  "block.minecraft.smooth_quartz": "Bllok kuarci i lëmuar",
  "block.minecraft.smooth_quartz_slab": "Rrasë kuarci e lëmuar",
  "block.minecraft.smooth_quartz_stairs": "Shkallë kuarci e lëmuar",
  "block.minecraft.smooth_red_sandstone": "Gur ranor i lëmuar i kuq",
  "block.minecraft.smooth_red_sandstone_slab": "Rrasë guri ranor e lëmuar e kuqe",
  "block.minecraft.smooth_red_sandstone_stairs": "Shkallë guri ranor e lëmuar e kuqe",
  "block.minecraft.smooth_sandstone": "Gur ranor i lëmuar",
  "block.minecraft.smooth_sandstone_slab": "Rrasë guri ranor e lëmuar",
  "block.minecraft.smooth_sandstone_stairs": "Shkallë guri ranor e lëmuar",
  "block.minecraft.smooth_stone": "Shkëmb i lëmuar",
  "block.minecraft.smooth_stone_slab": "Rrasë shkëmbi e lëmuar",
  "block.minecraft.sniffer_egg": "Veza e nuhatësit",
  "block.minecraft.snow": "Borë",
  "block.minecraft.snow_block": "Bllok bore",
  "block.minecraft.soul_campfire": "Zjarr kampi i shpirtrave",
  "block.minecraft.soul_fire": "Zjarr i shpirtrave",
  "block.minecraft.soul_lantern": "Fanar i shpirtrave",
  "block.minecraft.soul_sand": "Rërë shpirti",
  "block.minecraft.soul_soil": "Tokë e shpirtrave",
  "block.minecraft.soul_torch": "Pishtar i shpirtrave",
  "block.minecraft.soul_wall_torch": "Pishtar i shpirtrave në mur",
  "block.minecraft.spawn.not_valid": "Ju nuk keni shtrat ose spirancë të mbushur, ose ato janë të penguara",
  "block.minecraft.spawner": "Gjenerator i krijesave",
  "block.minecraft.spawner.desc1": "Ndërvepron me një vezë pjellëse:",
  "block.minecraft.spawner.desc2": "Përcakton llojin e krijesës",
  "block.minecraft.sponge": "Sfungjer",
  "block.minecraft.spore_blossom": "Lule me spore",
  "block.minecraft.spruce_button": "Buton bredhi",
  "block.minecraft.spruce_door": "Derë bredhi",
  "block.minecraft.spruce_fence": "Gardh bredhi",
  "block.minecraft.spruce_fence_gate": "Portë bredhi",
  "block.minecraft.spruce_hanging_sign": "Tabelë bredhi e varur",
  "block.minecraft.spruce_leaves": "Gjethe bredhit",
  "block.minecraft.spruce_log": "Dru bredhit",
  "block.minecraft.spruce_planks": "Dërrasa bredhi",
  "block.minecraft.spruce_pressure_plate": "Pllakë presioni bredhi",
  "block.minecraft.spruce_sapling": "Fidan bredhit",
  "block.minecraft.spruce_shelf": "Raft bredhi",
  "block.minecraft.spruce_sign": "Tabelë bredhi",
  "block.minecraft.spruce_slab": "Rrasë bredhi",
  "block.minecraft.spruce_stairs": "Shkallë bredhi",
  "block.minecraft.spruce_trapdoor": "Kapanxhë bredhi",
  "block.minecraft.spruce_wall_hanging_sign": "Tabelë bredhi e varur në mur",
  "block.minecraft.spruce_wall_sign": "Tabelë bredhi në mur",
  "block.minecraft.spruce_wood": "Trung bredhit",
  "block.minecraft.sticky_piston": "Piston ngjitës",
  "block.minecraft.stone": "Shkëmb",
  "block.minecraft.stone_brick_slab": "Rrasë shkëmbi të prerë",
  "block.minecraft.stone_brick_stairs": "Shkallë shkëmbi të prerë",
  "block.minecraft.stone_brick_wall": "Mur shkëmbi të prerë",
  "block.minecraft.stone_bricks": "Shkëmb i prerë",
  "block.minecraft.stone_button": "Buton guri",
  "block.minecraft.stone_pressure_plate": "Pllakë presioni guri",
  "block.minecraft.stone_slab": "Rrasë shkëmbi",
  "block.minecraft.stone_stairs": "Shkallë shkëmbi",
  "block.minecraft.stonecutter": "Gurgdhendës",
  "block.minecraft.stripped_acacia_log": "Dru akacisës pa lëvore",
  "block.minecraft.stripped_acacia_wood": "Trung akacisës pa lëvore",
  "block.minecraft.stripped_bamboo_block": "Bllok bambuje pa lëvore",
  "block.minecraft.stripped_birch_log": "Dru mështeknës pa lëvore",
  "block.minecraft.stripped_birch_wood": "Trung mështeknës pa lëvore",
  "block.minecraft.stripped_cherry_log": "Dru qershie pa lëvore",
  "block.minecraft.stripped_cherry_wood": "Trung qershie pa lëvore",
  "block.minecraft.stripped_crimson_hyphae": "Hife të kuqërremta pa lëvore",
  "block.minecraft.stripped_crimson_stem": "Kërcell i kuqërremtë pa lëvore",
  "block.minecraft.stripped_dark_oak_log": "Dru dushkut të errët pa lëvore",
  "block.minecraft.stripped_dark_oak_wood": "Trung dushkut të errët pa lëvore",
  "block.minecraft.stripped_jungle_log": "Dru xhunglës pa lëvore",
  "block.minecraft.stripped_jungle_wood": "Trung xhunglës pa lëvore",
  "block.minecraft.stripped_mangrove_log": "Dru mangrovës pa lëvore",
  "block.minecraft.stripped_mangrove_wood": "Trung mangrovës pa lëvore",
  "block.minecraft.stripped_oak_log": "Dru dushkut pa lëvore",
  "block.minecraft.stripped_oak_wood": "Trung dushkut pa lëvore",
  "block.minecraft.stripped_pale_oak_log": "Dru dushkut të zbehtë pa lëvore",
  "block.minecraft.stripped_pale_oak_wood": "Trung dushkut të zbehtë pa lëvore",
  "block.minecraft.stripped_spruce_log": "Dru bredhit pa lëvore",
  "block.minecraft.stripped_spruce_wood": "Trung bredhit pa lëvore",
  "block.minecraft.stripped_warped_hyphae": "Hife të çuditshme pa lëvore",
  "block.minecraft.stripped_warped_stem": "Kërcell i çuditshëm pa lëvore",
  "block.minecraft.structure_block": "Bllok strukturor",
  "block.minecraft.structure_void": "Boshllëk strukturor",
  "block.minecraft.sugar_cane": "Kallam sheqeri",
  "block.minecraft.sunflower": "Luledielli",
  "block.minecraft.suspicious_gravel": "Zhavorr i dyshimtë",
  "block.minecraft.suspicious_sand": "Rërë e dyshimtë",
  "block.minecraft.sweet_berry_bush": "Shkurre me manaferra të ëmbla",
  "block.minecraft.tall_dry_grass": "Bar i gjatë i thatë",
  "block.minecraft.tall_grass": "Bar i gjatë",
  "block.minecraft.tall_seagrass": "Bar i gjatë deti",
  "block.minecraft.target": "Shënjestër",
  "block.minecraft.terracotta": "Terrakotë",
  "block.minecraft.test_block": "Bllok testimi",
  "block.minecraft.test_instance_block": "Bllok i instancës së testimit",
  "block.minecraft.tinted_glass": "Qelqi i errët",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Shpërthimet e TNT-së janë të çaktivizuar",
  "block.minecraft.torch": "Pishtar",
  "block.minecraft.torchflower": "Lulepishtari",
  "block.minecraft.torchflower_crop": "Bimë lulepishtari",
  "block.minecraft.trapped_chest": "Arkë me kurth",
  "block.minecraft.trial_spawner": "Gjenerator i sfidës",
  "block.minecraft.tripwire": "Fijez",
  "block.minecraft.tripwire_hook": "Grep",
  "block.minecraft.tube_coral": "Koral tubi",
  "block.minecraft.tube_coral_block": "Bllok koral tubi",
  "block.minecraft.tube_coral_fan": "Kreshtë koral tubi",
  "block.minecraft.tube_coral_wall_fan": "Kreshtë koral tubi në mur",
  "block.minecraft.tuff": "Shtuf",
  "block.minecraft.tuff_brick_slab": "Rrasë shtufi e prerë",
  "block.minecraft.tuff_brick_stairs": "Shkallë shtufi të prerë",
  "block.minecraft.tuff_brick_wall": "Mur shtufi të prerë",
  "block.minecraft.tuff_bricks": "Shtuf i prerë",
  "block.minecraft.tuff_slab": "Rrasë shtufi",
  "block.minecraft.tuff_stairs": "Shkallë shtufi",
  "block.minecraft.tuff_wall": "Mur shtufi",
  "block.minecraft.turtle_egg": "Veza e breshkës",
  "block.minecraft.twisting_vines": "Hardhitë e përdredhura",
  "block.minecraft.twisting_vines_plant": "Bimë e hardhitë të përdredhura",
  "block.minecraft.vault": "Kasafortë",
  "block.minecraft.verdant_froglight": "Dritkosa jeshile",
  "block.minecraft.vine": "Hardhitë",
  "block.minecraft.void_air": "Ajri i boshllëkut",
  "block.minecraft.wall_torch": "Pishtar në mur",
  "block.minecraft.warped_button": "Buton i çuditshëm",
  "block.minecraft.warped_door": "Derë e çuditshme",
  "block.minecraft.warped_fence": "Gardh i çuditshëm",
  "block.minecraft.warped_fence_gate": "Portë e çuditshme",
  "block.minecraft.warped_fungus": "Kërpudhë e çuditshme",
  "block.minecraft.warped_hanging_sign": "Tabelë e çuditshme e varur",
  "block.minecraft.warped_hyphae": "Hife të çuditshme",
  "block.minecraft.warped_nylium": "Nilium i çuditshëm",
  "block.minecraft.warped_planks": "Dërrasa të çuditshme",
  "block.minecraft.warped_pressure_plate": "Pllakë presioni e çuditshme",
  "block.minecraft.warped_roots": "Rrënjët të çuditshme",
  "block.minecraft.warped_shelf": "Raft i çuditshëm",
  "block.minecraft.warped_sign": "Tabelë e çuditshme",
  "block.minecraft.warped_slab": "Rrasë e çuditshme",
  "block.minecraft.warped_stairs": "Shkallë e çuditshme",
  "block.minecraft.warped_stem": "Kërcell i çuditshëm",
  "block.minecraft.warped_trapdoor": "Kapanxhë e çuditshme",
  "block.minecraft.warped_wall_hanging_sign": "Tabelë e çuditshme e varur në mur",
  "block.minecraft.warped_wall_sign": "Tabelë e çuditshme në mur",
  "block.minecraft.warped_wart_block": "Bllok lythave të çuditshme",
  "block.minecraft.water": "Ujë",
  "block.minecraft.water_cauldron": "Kazan me ujë",
  "block.minecraft.waxed_chiseled_copper": "Bakër i gdhendur i dyllosur",
  "block.minecraft.waxed_copper_bars": "Kangjell bakri i dyllosur",
  "block.minecraft.waxed_copper_block": "Bllok bakri i dyllosur",
  "block.minecraft.waxed_copper_bulb": "Llambë bakri e dyllosur",
  "block.minecraft.waxed_copper_chain": "Zinxhir bakri i dyllosur",
  "block.minecraft.waxed_copper_chest": "Arkë bakri e dyllosur",
  "block.minecraft.waxed_copper_door": "Derë bakri e dyllosur",
  "block.minecraft.waxed_copper_golem_statue": "Statujë e golemit bakri e dyllosur",
  "block.minecraft.waxed_copper_grate": "Rrjetë bakri e dyllosur",
  "block.minecraft.waxed_copper_lantern": "Fanar bakri i dyllosur",
  "block.minecraft.waxed_copper_trapdoor": "Kapanxhë bakri i dyllosur",
  "block.minecraft.waxed_cut_copper": "Bakër i prerë i dyllosur",
  "block.minecraft.waxed_cut_copper_slab": "Rrasë bakri e prerë e dyllosur",
  "block.minecraft.waxed_cut_copper_stairs": "Shkallë bakri e prerë e dyllosur",
  "block.minecraft.waxed_exposed_chiseled_copper": "Bakër i gdhendur i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_copper": "Bllok bakri i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_copper_bars": "Kangjell bakri i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_copper_bulb": "Llambë bakri e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_copper_chain": "Zinxhir bakri i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_copper_chest": "Arkë bakri e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_copper_door": "Derë bakri e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statujë e golemit bakri e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_copper_grate": "Rrjetë bakri e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_copper_lantern": "Fanar bakri i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Kapanxhë bakri i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_cut_copper": "Bakër i prerë i ekspozuar i dyllosur",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Rrasë bakri e prerë e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Shkallë bakri e prerë e ekspozuar e dyllosur",
  "block.minecraft.waxed_exposed_lightning_rod": "Rrufepritës i ekspozuar i dyllosur",
  "block.minecraft.waxed_lightning_rod": "Rrufepritës i dyllosur",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Bakër i gdhendur i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_copper": "Bllok bakri i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_copper_bars": "Kangjell bakri i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_copper_bulb": "Llambë bakri e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_copper_chain": "Zinxhir bakri i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_copper_chest": "Arkë bakri e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_copper_door": "Derë bakri e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statujë e golemit bakri e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_copper_grate": "Rrjetë bakri e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_copper_lantern": "Fanar bakri i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Kapanxhë bakri i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_cut_copper": "Bakër i prerë i oksiduar i dyllosur",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Rrasë bakri e prerë e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Shkallë bakri e prerë e oksiduar e dyllosur",
  "block.minecraft.waxed_oxidized_lightning_rod": "Rrufepritës i oksiduar i dyllosur",
  "block.minecraft.waxed_weathered_chiseled_copper": "Bakër i gdhendur i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_copper": "Bllok bakri i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_copper_bars": "Kangjell bakri i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_copper_bulb": "Llambë bakri e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_copper_chain": "Zinxhir bakri i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_copper_chest": "Arkë bakri e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_copper_door": "Derë bakri e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statujë e golemit bakri e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_copper_grate": "Rrjetë bakri e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_copper_lantern": "Fanar bakri i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Kapanxhë bakri i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_cut_copper": "Bakër i prerë i gërryer i dyllosur",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Rrasë bakri e prerë e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Shkallë bakri e prerë e gërryer e dyllosur",
  "block.minecraft.waxed_weathered_lightning_rod": "Rrufepritës i gërryer i dyllosur",
  "block.minecraft.weathered_chiseled_copper": "Bakër i gdhendur i gërryer",
  "block.minecraft.weathered_copper": "Bllok bakri i gërryer",
  "block.minecraft.weathered_copper_bars": "Kangjell bakri i gërryer",
  "block.minecraft.weathered_copper_bulb": "Llambë bakri e gërryer",
  "block.minecraft.weathered_copper_chain": "Zinxhir bakri i gërryer",
  "block.minecraft.weathered_copper_chest": "Arkë bakri e gërryer",
  "block.minecraft.weathered_copper_door": "Derë bakri e gërryer",
  "block.minecraft.weathered_copper_golem_statue": "Statujë e golemit bakri e gërryer",
  "block.minecraft.weathered_copper_grate": "Rrjetë bakri e gërryer",
  "block.minecraft.weathered_copper_lantern": "Fanar bakri i gërryer",
  "block.minecraft.weathered_copper_trapdoor": "Kapanxhë bakri i gërryer",
  "block.minecraft.weathered_cut_copper": "Bakër i prerë i gërryer",
  "block.minecraft.weathered_cut_copper_slab": "Rrasë bakri e prerë e gërryer",
  "block.minecraft.weathered_cut_copper_stairs": "Shkallë bakri e prerë e gërryer",
  "block.minecraft.weathered_lightning_rod": "Rrufepritës i gërryer",
  "block.minecraft.weeping_vines": "Hardhitë që qajnë",
  "block.minecraft.weeping_vines_plant": "Bimë e hardhitë që qajnë",
  "block.minecraft.wet_sponge": "Sfungjer i lagur",
  "block.minecraft.wheat": "Bimë gruri",
  "block.minecraft.white_banner": "Banderolë e bardhë",
  "block.minecraft.white_bed": "Shtrat i bardhë",
  "block.minecraft.white_candle": "Qiri i bardhë",
  "block.minecraft.white_candle_cake": "Tortë me qirinj të bardhë",
  "block.minecraft.white_carpet": "Qilim i bardhë",
  "block.minecraft.white_concrete": "Beton i bardhë",
  "block.minecraft.white_concrete_powder": "Pluhur betoni të bardhë",
  "block.minecraft.white_glazed_terracotta": "Terrakotë me xham të bardhë",
  "block.minecraft.white_shulker_box": "Kutia Shulker-it e bardhë",
  "block.minecraft.white_stained_glass": "Qelqi i bardhë",
  "block.minecraft.white_stained_glass_pane": "Xham i bardhë",
  "block.minecraft.white_terracotta": "Terrakotë e bardhë",
  "block.minecraft.white_tulip": "Tulipan i bardhë",
  "block.minecraft.white_wool": "Lesh i bardhë",
  "block.minecraft.wildflowers": "Lule të egra",
  "block.minecraft.wither_rose": "Trëndafil i Wither-it",
  "block.minecraft.wither_skeleton_skull": "Kafkë skeleti të Wither-it",
  "block.minecraft.wither_skeleton_wall_skull": "Kafkë skeleti të Wither-it në mur",
  "block.minecraft.yellow_banner": "Banderolë e verdhë",
  "block.minecraft.yellow_bed": "Shtrat i verdhë",
  "block.minecraft.yellow_candle": "Qiri i verdhë",
  "block.minecraft.yellow_candle_cake": "Tortë me qirinj të verdhë",
  "block.minecraft.yellow_carpet": "Qilim i verdhë",
  "block.minecraft.yellow_concrete": "Beton i verdhë",
  "block.minecraft.yellow_concrete_powder": "Pluhur betoni të verdhë",
  "block.minecraft.yellow_glazed_terracotta": "Terrakotë me xham të verdhë",
  "block.minecraft.yellow_shulker_box": "Kutia Shulker-it e verdhë",
  "block.minecraft.yellow_stained_glass": "Qelqi i verdhë",
  "block.minecraft.yellow_stained_glass_pane": "Xham i verdhë",
  "block.minecraft.yellow_terracotta": "Terrakotë e verdhë",
  "block.minecraft.yellow_wool": "Lesh i verdhë",
  "block.minecraft.zombie_head": "Kokë zombie",
  "block.minecraft.zombie_wall_head": "Kokë zombie në mur",
  "item.minecraft.acacia_boat": "Varkë akacisës",
  "item.minecraft.acacia_chest_boat": "Varkë magazinimi akacisës",
  "item.minecraft.allay_spawn_egg": "Veza pjellëse e Allay-it",
  "item.minecraft.amethyst_shard": "Copa ametisti",
  "item.minecraft.angler_pottery_shard": "Copë qeramike e peshkatarit",
  "item.minecraft.angler_pottery_sherd": "Copë qeramike e peshkatarit",
  "item.minecraft.apple": "Mollë",
  "item.minecraft.archer_pottery_shard": "Copë qeramike e shigjetarit",
  "item.minecraft.archer_pottery_sherd": "Copë qeramike e shigjetarit",
  "item.minecraft.armadillo_scute": "Lëvozhgë armadilli",
  "item.minecraft.armadillo_spawn_egg": "Veza pjellëse e armadillit",
  "item.minecraft.armor_stand": "Parzmore mbajtës",
  "item.minecraft.arms_up_pottery_shard": "Copë qeramike e trupit të njeriut",
  "item.minecraft.arms_up_pottery_sherd": "Copë qeramike e trupit të njeriut",
  "item.minecraft.arrow": "Shigjetë",
  "item.minecraft.axolotl_bucket": "Aksolotël në kovë",
  "item.minecraft.axolotl_spawn_egg": "Veza pjellëse e aksolotëlit",
  "item.minecraft.baked_potato": "Patate e pjekur",
  "item.minecraft.bamboo_chest_raft": "Trap magazinimi bambuje",
  "item.minecraft.bamboo_raft": "Trap bambuje",
  "item.minecraft.bat_spawn_egg": "Veza pjellëse e lakuriqit",
  "item.minecraft.bee_spawn_egg": "Veza pjellëse e bletës",
  "item.minecraft.beef": "Mish lopë i papjekur",
  "item.minecraft.beetroot": "Panxhar",
  "item.minecraft.beetroot_seeds": "Fara panxhari",
  "item.minecraft.beetroot_soup": "Supë panxhari",
  "item.minecraft.birch_boat": "Varkë mështeknës",
  "item.minecraft.birch_chest_boat": "Varkë magazinimi mështeknës",
  "item.minecraft.black_bundle": "Çantë e zezë",
  "item.minecraft.black_dye": "Bojë e zezë",
  "item.minecraft.black_harness": "Rrip me mbulesë të zezë",
  "item.minecraft.blade_pottery_shard": "Copë qeramike e shpatës",
  "item.minecraft.blade_pottery_sherd": "Copë qeramike e shpatës",
  "item.minecraft.blaze_powder": "Pluhur Blejzit",
  "item.minecraft.blaze_rod": "Shkop i Blejzit",
  "item.minecraft.blaze_spawn_egg": "Veza pjellëse e Blejzit",
  "item.minecraft.blue_bundle": "Çantë blu",
  "item.minecraft.blue_dye": "Bojë blu",
  "item.minecraft.blue_egg": "Vezë blu",
  "item.minecraft.blue_harness": "Rrip me mbulesë blu",
  "item.minecraft.bogged_spawn_egg": "Veza pjellëse e skeletit moçal",
  "item.minecraft.bolt_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Zbukurim i armaturës së bulonit",
  "item.minecraft.bone": "Kockë",
  "item.minecraft.bone_meal": "Pluhur kockash",
  "item.minecraft.book": "Libër",
  "item.minecraft.bordure_indented_banner_pattern": "Modeli me kaçurrela për banderolën",
  "item.minecraft.bow": "Hark",
  "item.minecraft.bowl": "Tas",
  "item.minecraft.bread": "Bukë",
  "item.minecraft.breeze_rod": "Shkop i Brizit",
  "item.minecraft.breeze_spawn_egg": "Veza pjellëse e Brizit",
  "item.minecraft.brewer_pottery_shard": "Copë qeramike e alkimistit",
  "item.minecraft.brewer_pottery_sherd": "Copë qeramike e alkimistit",
  "item.minecraft.brewing_stand": "Distileri",
  "item.minecraft.brick": "Tullë",
  "item.minecraft.brown_bundle": "Çantë e kaftë",
  "item.minecraft.brown_dye": "Bojë kafe",
  "item.minecraft.brown_egg": "Vezë e kaftë",
  "item.minecraft.brown_harness": "Rrip me mbulesë të kaftë",
  "item.minecraft.brush": "Furçë",
  "item.minecraft.bucket": "Kovë",
  "item.minecraft.bundle": "Çantë",
  "item.minecraft.bundle.empty": "E zbrazët",
  "item.minecraft.bundle.empty.description": "Mund të mbajë një grumbull me sende të ndryshme",
  "item.minecraft.bundle.full": "I plotë",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Copë qeramike e zjarrit",
  "item.minecraft.burn_pottery_sherd": "Copë qeramike e zjarrit",
  "item.minecraft.camel_husk_spawn_egg": "Veza pjellëse e dromedarit të momifikuar",
  "item.minecraft.camel_spawn_egg": "Veza pjellëse e dromedarit",
  "item.minecraft.carrot": "Karrotë",
  "item.minecraft.carrot_on_a_stick": "Karrot në shkop",
  "item.minecraft.cat_spawn_egg": "Veza pjellëse e maces",
  "item.minecraft.cauldron": "Kazan",
  "item.minecraft.cave_spider_spawn_egg": "Veza pjellëse e merimangës së shpellës",
  "item.minecraft.chainmail_boots": "Çizme zinxhirësh",
  "item.minecraft.chainmail_chestplate": "Parzmore zinxhirësh",
  "item.minecraft.chainmail_helmet": "Përkrenare zinxhirësh",
  "item.minecraft.chainmail_leggings": "Dollakë zinxhirësh",
  "item.minecraft.charcoal": "Qymyr druri",
  "item.minecraft.cherry_boat": "Varkë qershie",
  "item.minecraft.cherry_chest_boat": "Varkë magazinimi qershie",
  "item.minecraft.chest_minecart": "Karrocë magazinimi",
  "item.minecraft.chicken": "Pulë e papjekur",
  "item.minecraft.chicken_spawn_egg": "Veza pjellëse e pulës",
  "item.minecraft.chorus_fruit": "Korus",
  "item.minecraft.clay_ball": "Copë argjile",
  "item.minecraft.clock": "Orë",
  "item.minecraft.coal": "Qymyrgur",
  "item.minecraft.coast_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Zbukurim i armaturës së bregdetit",
  "item.minecraft.cocoa_beans": "Kokrra kakaoje",
  "item.minecraft.cod": "Merluc i papjekur",
  "item.minecraft.cod_bucket": "Merluc në kovë",
  "item.minecraft.cod_spawn_egg": "Veza pjellëse e merlucit",
  "item.minecraft.command_block_minecart": "Karrocë me bllok komandues",
  "item.minecraft.compass": "Busull",
  "item.minecraft.cooked_beef": "Mish lopë i pjekur",
  "item.minecraft.cooked_chicken": "Pulë e pjekur",
  "item.minecraft.cooked_cod": "Merluc i pjekur",
  "item.minecraft.cooked_mutton": "Mish deleje i pjekur",
  "item.minecraft.cooked_porkchop": "Mish derri i pjekur",
  "item.minecraft.cooked_rabbit": "Mish lepuri i pjekur",
  "item.minecraft.cooked_salmon": "Salmon i pjekur",
  "item.minecraft.cookie": "Biskotë",
  "item.minecraft.copper_axe": "Sëpatë bakri",
  "item.minecraft.copper_boots": "Çizme bakri",
  "item.minecraft.copper_chestplate": "Parzmore bakri",
  "item.minecraft.copper_golem_spawn_egg": "Veza pjellëse e golemit të bakrit",
  "item.minecraft.copper_helmet": "Përkrenare bakri",
  "item.minecraft.copper_hoe": "Kosë bakri",
  "item.minecraft.copper_horse_armor": "Parzmore bakri për kalë",
  "item.minecraft.copper_ingot": "Shufër bakri",
  "item.minecraft.copper_leggings": "Dollakë bakri",
  "item.minecraft.copper_nautilus_armor": "Parzmore bakri për nautilus",
  "item.minecraft.copper_nugget": "Copë bakri",
  "item.minecraft.copper_pickaxe": "Kazmë bakri",
  "item.minecraft.copper_shovel": "Lopatë bakri",
  "item.minecraft.copper_spear": "Shtiza bakri",
  "item.minecraft.copper_sword": "Shpatë bakri",
  "item.minecraft.cow_spawn_egg": "Veza pjellëse e lopës",
  "item.minecraft.creaking_spawn_egg": "Veza pjellëse e kërcitësit",
  "item.minecraft.creeper_banner_pattern": "Modeli i banderolës",
  "item.minecraft.creeper_banner_pattern.desc": "Fytyra e Creeper-it",
  "item.minecraft.creeper_banner_pattern.new": "Modeli i fytyrës e Creeper-it për banderolën",
  "item.minecraft.creeper_spawn_egg": "Veza pjellëse e Creeper-it",
  "item.minecraft.crossbow": "Harku kryq",
  "item.minecraft.crossbow.projectile": "Predha:",
  "item.minecraft.crossbow.projectile.multiple": "Predha: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Predha: %s",
  "item.minecraft.cyan_bundle": "Çantë cian",
  "item.minecraft.cyan_dye": "Bojë cian",
  "item.minecraft.cyan_harness": "Rrip me mbulesë cian",
  "item.minecraft.danger_pottery_shard": "Copë qeramike e rrezikut",
  "item.minecraft.danger_pottery_sherd": "Copë qeramike e rrezikut",
  "item.minecraft.dark_oak_boat": "Varkë dushkut të errët",
  "item.minecraft.dark_oak_chest_boat": "Varkë magazinimi dushkut të errët",
  "item.minecraft.debug_stick": "Shkop korrigjimi",
  "item.minecraft.debug_stick.empty": "%s nuk ka asnjë pronë",
  "item.minecraft.debug_stick.select": "\"%s\" e zgjedhur (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" në %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Sëpatë diamanti",
  "item.minecraft.diamond_boots": "Çizme diamanti",
  "item.minecraft.diamond_chestplate": "Parzmore diamanti",
  "item.minecraft.diamond_helmet": "Përkrenare diamanti",
  "item.minecraft.diamond_hoe": "Kosë diamanti",
  "item.minecraft.diamond_horse_armor": "Parzmore diamanti për kalë",
  "item.minecraft.diamond_leggings": "Dollakë diamanti",
  "item.minecraft.diamond_nautilus_armor": "Parzmore diamanti për nautilus",
  "item.minecraft.diamond_pickaxe": "Kazmë diamanti",
  "item.minecraft.diamond_shovel": "Lopatë diamanti",
  "item.minecraft.diamond_spear": "Shtiza diamanti",
  "item.minecraft.diamond_sword": "Shpatë diamanti",
  "item.minecraft.disc_fragment_5": "Fragment disku",
  "item.minecraft.disc_fragment_5.desc": "Disk muzikor - 5",
  "item.minecraft.dolphin_spawn_egg": "Veza pjellëse e delfinit",
  "item.minecraft.donkey_spawn_egg": "Veza pjellëse e gomarit",
  "item.minecraft.dragon_breath": "Frymë e dragoit",
  "item.minecraft.dried_kelp": "Leshterik i tharë",
  "item.minecraft.drowned_spawn_egg": "Veza pjellëse e përmbyturit",
  "item.minecraft.dune_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Zbukurim i armaturës së dunës",
  "item.minecraft.echo_shard": "Fragment i jehonës",
  "item.minecraft.egg": "Vezë",
  "item.minecraft.elder_guardian_spawn_egg": "Veza pjellëse e gardianit të madh",
  "item.minecraft.elytra": "Flatra",
  "item.minecraft.emerald": "Smerald",
  "item.minecraft.enchanted_book": "Libër përforcimi",
  "item.minecraft.enchanted_golden_apple": "Mollë e artë e magjepsur",
  "item.minecraft.end_crystal": "Kristal i Ender-it",
  "item.minecraft.ender_dragon_spawn_egg": "Veza pjellëse e Dragoit Ender",
  "item.minecraft.ender_eye": "Syri i Ender-it",
  "item.minecraft.ender_pearl": "Perlë e Ender-it",
  "item.minecraft.enderman_spawn_egg": "Veza pjellëse e Enderman-it",
  "item.minecraft.endermite_spawn_egg": "Veza pjellëse e Endermitit",
  "item.minecraft.evoker_spawn_egg": "Veza pjellëse e yshtësit",
  "item.minecraft.experience_bottle": "Balonë përvoje",
  "item.minecraft.explorer_pottery_shard": "Copë qeramike e eksploruesit",
  "item.minecraft.explorer_pottery_sherd": "Copë qeramike e eksploruesit",
  "item.minecraft.eye_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Zbukurim i armaturës së syrit",
  "item.minecraft.feather": "Pendë",
  "item.minecraft.fermented_spider_eye": "Syri i merimangës së fermentuar",
  "item.minecraft.field_masoned_banner_pattern": "Modeli fushë me tulla për banderolën",
  "item.minecraft.filled_map": "Hartë",
  "item.minecraft.fire_charge": "Lëmsh i zjarrtë",
  "item.minecraft.firework_rocket": "Raketë fishekzjarresh",
  "item.minecraft.firework_rocket.flight": "Kohëzgjatja e fluturimit:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Yll fishekzjarresh",
  "item.minecraft.firework_star.black": "I zi",
  "item.minecraft.firework_star.blue": "Blu",
  "item.minecraft.firework_star.brown": "I kaftë",
  "item.minecraft.firework_star.custom_color": "Të personalizuar",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Zbehet në",
  "item.minecraft.firework_star.flicker": "Shkëndija",
  "item.minecraft.firework_star.gray": "Gri",
  "item.minecraft.firework_star.green": "I gjelbër",
  "item.minecraft.firework_star.light_blue": "Blu e lehtë",
  "item.minecraft.firework_star.light_gray": "Gri e lehtë",
  "item.minecraft.firework_star.lime": "I gjelbër e çelët",
  "item.minecraft.firework_star.magenta": "I purpurtë",
  "item.minecraft.firework_star.orange": "Portokalli",
  "item.minecraft.firework_star.pink": "Rozë",
  "item.minecraft.firework_star.purple": "Vjollcë",
  "item.minecraft.firework_star.red": "I kuq",
  "item.minecraft.firework_star.shape": "Formë e panjohur",
  "item.minecraft.firework_star.shape.burst": "Shpërthim",
  "item.minecraft.firework_star.shape.creeper": "Në formë Creeper-i",
  "item.minecraft.firework_star.shape.large_ball": "Top i madh",
  "item.minecraft.firework_star.shape.small_ball": "Top i vogël",
  "item.minecraft.firework_star.shape.star": "Në formë ylli",
  "item.minecraft.firework_star.trail": "Shteg",
  "item.minecraft.firework_star.white": "I bardhë",
  "item.minecraft.firework_star.yellow": "I verdhë",
  "item.minecraft.fishing_rod": "Kallam peshkimi",
  "item.minecraft.flint": "Strall",
  "item.minecraft.flint_and_steel": "Çakmak",
  "item.minecraft.flow_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Zbukurim i armaturës së vorbullave",
  "item.minecraft.flow_banner_pattern": "Modeli i banderolës",
  "item.minecraft.flow_banner_pattern.desc": "Vorbull",
  "item.minecraft.flow_banner_pattern.new": "Modeli vorbull për banderolën",
  "item.minecraft.flow_pottery_sherd": "Copë qeramike e vorbullës",
  "item.minecraft.flower_banner_pattern": "Modeli i banderolës",
  "item.minecraft.flower_banner_pattern.desc": "Lule",
  "item.minecraft.flower_banner_pattern.new": "Modeli lule për banderolën",
  "item.minecraft.flower_pot": "Vazo lulesh",
  "item.minecraft.fox_spawn_egg": "Veza pjellëse e dhelprës",
  "item.minecraft.friend_pottery_shard": "Copë qeramike e shokut",
  "item.minecraft.friend_pottery_sherd": "Copë qeramike e shokut",
  "item.minecraft.frog_spawn_egg": "Veza pjellëse e bretkosës",
  "item.minecraft.furnace_minecart": "Karrocë me furrë",
  "item.minecraft.ghast_spawn_egg": "Veza pjellëse e Ghastit",
  "item.minecraft.ghast_tear": "Loti i Ghast-it",
  "item.minecraft.glass_bottle": "Shishe xhami",
  "item.minecraft.glistering_melon_slice": "Fetë shalqiri që shkëlqen",
  "item.minecraft.globe_banner_pattern": "Modeli i banderolës",
  "item.minecraft.globe_banner_pattern.desc": "Glob",
  "item.minecraft.globe_banner_pattern.new": "Modeli glob për banderolën",
  "item.minecraft.glow_berries": "Manaferrat e ndritshëm",
  "item.minecraft.glow_ink_sac": "Thes boje të ndritshëm",
  "item.minecraft.glow_item_frame": "Kornizë e shndritshme",
  "item.minecraft.glow_squid_spawn_egg": "Veza pjellëse e oktapodit shkëlqyes",
  "item.minecraft.glowstone_dust": "Pluhur guri të ndritshëm",
  "item.minecraft.goat_horn": "Briri i dhisë",
  "item.minecraft.goat_spawn_egg": "Veza pjellëse e dhisë",
  "item.minecraft.gold_ingot": "Shufër ari",
  "item.minecraft.gold_nugget": "Copë ari",
  "item.minecraft.golden_apple": "Mollë e artë",
  "item.minecraft.golden_axe": "Sëpatë ari",
  "item.minecraft.golden_boots": "Çizme ari",
  "item.minecraft.golden_carrot": "Karrotë e artë",
  "item.minecraft.golden_chestplate": "Parzmore ari",
  "item.minecraft.golden_helmet": "Përkrenare ari",
  "item.minecraft.golden_hoe": "Kosë ari",
  "item.minecraft.golden_horse_armor": "Parzmore ari për kalë",
  "item.minecraft.golden_leggings": "Dollakë ari",
  "item.minecraft.golden_nautilus_armor": "Parzmore ari për nautilus",
  "item.minecraft.golden_pickaxe": "Kazmë ari",
  "item.minecraft.golden_shovel": "Lopatë ari",
  "item.minecraft.golden_spear": "Shtiza ari",
  "item.minecraft.golden_sword": "Shpatë ari",
  "item.minecraft.gray_bundle": "Çantë gri",
  "item.minecraft.gray_dye": "Bojë gri",
  "item.minecraft.gray_harness": "Rrip me mbulesë gri",
  "item.minecraft.green_bundle": "Çantë e gjelbër",
  "item.minecraft.green_dye": "Bojë e gjelbër",
  "item.minecraft.green_harness": "Rrip me mbulesë të gjelbër",
  "item.minecraft.guardian_spawn_egg": "Veza pjellëse e kujdestarit",
  "item.minecraft.gunpowder": "Barut",
  "item.minecraft.guster_banner_pattern": "Modeli i banderolës",
  "item.minecraft.guster_banner_pattern.desc": "Oshnik",
  "item.minecraft.guster_banner_pattern.new": "Modeli oshnik për banderolën",
  "item.minecraft.guster_pottery_sherd": "Copë qeramike oshniku",
  "item.minecraft.happy_ghast_spawn_egg": "Veza pjellëse e Ghastit të lumtur",
  "item.minecraft.harness": "Rrip me mbulesë",
  "item.minecraft.heart_of_the_sea": "Zemër e detit",
  "item.minecraft.heart_pottery_shard": "Copë qeramike e zemrës",
  "item.minecraft.heart_pottery_sherd": "Copë qeramike e zemrës",
  "item.minecraft.heartbreak_pottery_shard": "Copë qeramike me zemër të thyer",
  "item.minecraft.heartbreak_pottery_sherd": "Copë qeramike me zemër të thyer",
  "item.minecraft.hoglin_spawn_egg": "Veza pjellëse e Hoglin-it",
  "item.minecraft.honey_bottle": "Shishe mjalti",
  "item.minecraft.honeycomb": "Huall mjalti",
  "item.minecraft.hopper_minecart": "Karrocë me hinkë",
  "item.minecraft.horse_spawn_egg": "Veza pjellëse e kalit",
  "item.minecraft.host_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.host_armor_trim_smithing_template.new": "Zbukurim i armaturës së nikoqirit",
  "item.minecraft.howl_pottery_shard": "Copë qeramike e ujkut",
  "item.minecraft.howl_pottery_sherd": "Copë qeramike e ujkut",
  "item.minecraft.husk_spawn_egg": "Veza pjellëse e mumjes",
  "item.minecraft.ink_sac": "Thes boje",
  "item.minecraft.iron_axe": "Sëpatë hekuri",
  "item.minecraft.iron_boots": "Çizme hekuri",
  "item.minecraft.iron_chestplate": "Parzmore hekuri",
  "item.minecraft.iron_golem_spawn_egg": "Veza pjellëse e golemit të hekurt",
  "item.minecraft.iron_helmet": "Përkrenare hekuri",
  "item.minecraft.iron_hoe": "Kosë hekuri",
  "item.minecraft.iron_horse_armor": "Parzmore hekuri për kalë",
  "item.minecraft.iron_ingot": "Shufër hekuri",
  "item.minecraft.iron_leggings": "Dollakë hekuri",
  "item.minecraft.iron_nautilus_armor": "Parzmore hekuri për nautilus",
  "item.minecraft.iron_nugget": "Copë hekuri",
  "item.minecraft.iron_pickaxe": "Kazmë hekuri",
  "item.minecraft.iron_shovel": "Lopatë hekuri",
  "item.minecraft.iron_spear": "Shtiza hekuri",
  "item.minecraft.iron_sword": "Shpatë hekuri",
  "item.minecraft.item_frame": "Kornizë",
  "item.minecraft.jungle_boat": "Varkë xhunglës",
  "item.minecraft.jungle_chest_boat": "Varkë magazinimi xhunglës",
  "item.minecraft.knowledge_book": "Libri i diturisë",
  "item.minecraft.lapis_lazuli": "Lazurit",
  "item.minecraft.lava_bucket": "Kovë me llavë",
  "item.minecraft.lead": "Litar",
  "item.minecraft.leather": "Lëkurë",
  "item.minecraft.leather_boots": "Çizme lëkure",
  "item.minecraft.leather_chestplate": "Tunikë lëkure",
  "item.minecraft.leather_helmet": "Kapelë lëkure",
  "item.minecraft.leather_horse_armor": "Parzmore lëkures për kalë",
  "item.minecraft.leather_leggings": "Pantallona lëkure",
  "item.minecraft.light_blue_bundle": "Çantë blu e lehtë",
  "item.minecraft.light_blue_dye": "Bojë blu e lehtë",
  "item.minecraft.light_blue_harness": "Rrip me mbulesë blu të lehtë",
  "item.minecraft.light_gray_bundle": "Çantë gri e lehtë",
  "item.minecraft.light_gray_dye": "Bojë gri e lehtë",
  "item.minecraft.light_gray_harness": "Rrip me mbulesë gri të lehtë",
  "item.minecraft.lime_bundle": "Çantë e gjelbër e çelët",
  "item.minecraft.lime_dye": "Bojë e gjelbër e çelët",
  "item.minecraft.lime_harness": "Rrip me mbulesë të gjelbër e çelët",
  "item.minecraft.lingering_potion": "Lëng që zgjat",
  "item.minecraft.lingering_potion.effect.awkward": "Lëng i çuditshëm që zgjat",
  "item.minecraft.lingering_potion.effect.empty": "Lëng që zgjat jo i krijueshëm",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lëng i rezistencës ndaj zjarrit që zgjat",
  "item.minecraft.lingering_potion.effect.harming": "Lëng i dëmtimit që zgjat",
  "item.minecraft.lingering_potion.effect.healing": "Lëng i shërimit që zgjat",
  "item.minecraft.lingering_potion.effect.infested": "Lëng i infektimit që zgjat",
  "item.minecraft.lingering_potion.effect.invisibility": "Lëng i padukshmërisë që zgjat",
  "item.minecraft.lingering_potion.effect.leaping": "Lëng i kërcimit që zgjat",
  "item.minecraft.lingering_potion.effect.levitation": "Lëng i levitacionit që zgjat",
  "item.minecraft.lingering_potion.effect.luck": "Lëng i fatit që zgjat",
  "item.minecraft.lingering_potion.effect.mundane": "Lëng i zakonshëm që zgjat",
  "item.minecraft.lingering_potion.effect.night_vision": "Lëng i shikimit të natës që zgjat",
  "item.minecraft.lingering_potion.effect.oozing": "Lëng i viskozitetit që zgjat",
  "item.minecraft.lingering_potion.effect.poison": "Lëng i helmimit që zgjat",
  "item.minecraft.lingering_potion.effect.regeneration": "Lëng i rigjenerimit që zgjat",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lëng i rënies së ngadaltë që zgjat",
  "item.minecraft.lingering_potion.effect.slowness": "Lëng i ngadalësisë që zgjat",
  "item.minecraft.lingering_potion.effect.strength": "Lëng i forcës që zgjat",
  "item.minecraft.lingering_potion.effect.swiftness": "Lëng i shpejtësisë që zgjat",
  "item.minecraft.lingering_potion.effect.thick": "Lëng i trashë që zgjat",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lëng i Breshkës Mjeshtër që zgjat",
  "item.minecraft.lingering_potion.effect.water": "Shishe uji që zgjat",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lëng i frymëmarrjes nën ujë që zgjat",
  "item.minecraft.lingering_potion.effect.weakness": "Lëng i dobësisë që zgjat",
  "item.minecraft.lingering_potion.effect.weaving": "Lëng i gërshetimit që zgjat",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lëng i ngarkimit të erës që zgjat",
  "item.minecraft.llama_spawn_egg": "Veza pjellëse e lamës",
  "item.minecraft.lodestone_compass": "Busull e magnetizuar",
  "item.minecraft.mace": "Çekan",
  "item.minecraft.magenta_bundle": "Çantë e purpurtë",
  "item.minecraft.magenta_dye": "Bojë e purpurt",
  "item.minecraft.magenta_harness": "Rrip me mbulesë të purpurtë",
  "item.minecraft.magma_cream": "Krem magmaje",
  "item.minecraft.magma_cube_spawn_egg": "Veza pjellëse e kubit të magmës",
  "item.minecraft.mangrove_boat": "Varkë mangrovës",
  "item.minecraft.mangrove_chest_boat": "Varkë magazinimi mangrovës",
  "item.minecraft.map": "Hartë bosh",
  "item.minecraft.melon_seeds": "Fara shalqiri",
  "item.minecraft.melon_slice": "Fetë shalqiri",
  "item.minecraft.milk_bucket": "Kovë me qumësht",
  "item.minecraft.minecart": "Karrocë",
  "item.minecraft.miner_pottery_shard": "Copë qeramike e minatorit",
  "item.minecraft.miner_pottery_sherd": "Copë qeramike e minatorit",
  "item.minecraft.mojang_banner_pattern": "Modeli i banderolës",
  "item.minecraft.mojang_banner_pattern.desc": "Stemë",
  "item.minecraft.mojang_banner_pattern.new": "Modeli stemë për banderolën",
  "item.minecraft.mooshroom_spawn_egg": "Veza pjellëse e Mooshroom-it",
  "item.minecraft.mourner_pottery_shard": "Copë qeramike e vajtimtarit",
  "item.minecraft.mourner_pottery_sherd": "Copë qeramike e vajtimtarit",
  "item.minecraft.mule_spawn_egg": "Veza pjellëse e mushkës",
  "item.minecraft.mushroom_stew": "Supë kërpudhash",
  "item.minecraft.music_disc_11": "Disk muzikor",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disk muzikor",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disk muzikor",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disk muzikor",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disk muzikor",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disk muzikor",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disk muzikor",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disk muzikor",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Rain - Creator (kuti muzikore)",
  "item.minecraft.music_disc_far": "Disk muzikor",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disk muzikor",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disk muzikor",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disk muzikor",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disk muzikor",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disk muzikor",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disk muzikor",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disk muzikor",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disk muzikor",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disk muzikor",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disk muzikor",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disk muzikor",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disk muzikor",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Mish deleje i papjekur",
  "item.minecraft.name_tag": "Etiketë",
  "item.minecraft.nautilus_shell": "Guaskë nautilusi",
  "item.minecraft.nautilus_spawn_egg": "Veza pjellëse e nautilusit",
  "item.minecraft.nether_brick": "Tullë e Nether-it",
  "item.minecraft.nether_star": "Yll i Nether-it",
  "item.minecraft.nether_wart": "Lythat e Nether-it",
  "item.minecraft.netherite_axe": "Sëpatë Netheriti",
  "item.minecraft.netherite_boots": "Çizme Netheriti",
  "item.minecraft.netherite_chestplate": "Parzmore Netheriti",
  "item.minecraft.netherite_helmet": "Përkrenare Netheriti",
  "item.minecraft.netherite_hoe": "Kosë Netheriti",
  "item.minecraft.netherite_horse_armor": "Parzmore Netheriti për kalë",
  "item.minecraft.netherite_ingot": "Shufër Netheriti",
  "item.minecraft.netherite_leggings": "Dollakë Netheriti",
  "item.minecraft.netherite_nautilus_armor": "Parzmore netheriti për nautilus",
  "item.minecraft.netherite_pickaxe": "Kazmë Netheriti",
  "item.minecraft.netherite_scrap": "Fragment Netheriti",
  "item.minecraft.netherite_shovel": "Lopatë Netheriti",
  "item.minecraft.netherite_spear": "Shtiza netheriti",
  "item.minecraft.netherite_sword": "Shpatë Netheriti",
  "item.minecraft.netherite_upgrade_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Përmirësim Netheriti",
  "item.minecraft.oak_boat": "Varkë dushkut",
  "item.minecraft.oak_chest_boat": "Varkë magazinimi dushkut",
  "item.minecraft.ocelot_spawn_egg": "Veza pjellëse e oçelotit",
  "item.minecraft.ominous_bottle": "Shishe ogurzi",
  "item.minecraft.ominous_trial_key": "Çelës sprove ogurzi",
  "item.minecraft.orange_bundle": "Çantë e portokalltë",
  "item.minecraft.orange_dye": "Bojë portokalli",
  "item.minecraft.orange_harness": "Rrip me mbulesë portokalli",
  "item.minecraft.painting": "Pikturë",
  "item.minecraft.pale_oak_boat": "Varkë dushkut të zbehtë",
  "item.minecraft.pale_oak_chest_boat": "Varkë magazinimi dushkut të zbehtë",
  "item.minecraft.panda_spawn_egg": "Veza pjellëse e pandës",
  "item.minecraft.paper": "Letër",
  "item.minecraft.parched_spawn_egg": "Veza pjellëse e përcëlluarit",
  "item.minecraft.parrot_spawn_egg": "Veza pjellëse e papagallit",
  "item.minecraft.phantom_membrane": "Membrana Fantazmës",
  "item.minecraft.phantom_spawn_egg": "Veza pjellëse e Fantazmës",
  "item.minecraft.pig_spawn_egg": "Veza pjellëse e derrit",
  "item.minecraft.piglin_banner_pattern": "Modeli i banderolës",
  "item.minecraft.piglin_banner_pattern.desc": "Feçkë",
  "item.minecraft.piglin_banner_pattern.new": "Modeli i feçkës për banderolën",
  "item.minecraft.piglin_brute_spawn_egg": "Veza pjellëse e Piglin-it të egër",
  "item.minecraft.piglin_spawn_egg": "Veza pjellëse e Piglin-it",
  "item.minecraft.pillager_spawn_egg": "Veza pjellëse e plaçkitësit",
  "item.minecraft.pink_bundle": "Çantë rozë",
  "item.minecraft.pink_dye": "Bojë rozë",
  "item.minecraft.pink_harness": "Rrip me mbulesë rozë",
  "item.minecraft.pitcher_plant": "Shtambë tropikale",
  "item.minecraft.pitcher_pod": "Bishtaja shtambës tropikale",
  "item.minecraft.plenty_pottery_shard": "Copë qeramike e pasurisë",
  "item.minecraft.plenty_pottery_sherd": "Copë qeramike e pasurisë",
  "item.minecraft.poisonous_potato": "Patate e helmuar",
  "item.minecraft.polar_bear_spawn_egg": "Veza pjellëse e ariut polar",
  "item.minecraft.popped_chorus_fruit": "Korus i pëlcitur",
  "item.minecraft.porkchop": "Mish derri i papjekur",
  "item.minecraft.potato": "Patate",
  "item.minecraft.potion": "Lëng",
  "item.minecraft.potion.effect.awkward": "Lëng i çuditshëm",
  "item.minecraft.potion.effect.empty": "Lëng jo i krijueshëm",
  "item.minecraft.potion.effect.fire_resistance": "Lëng i rezistencës ndaj zjarrit",
  "item.minecraft.potion.effect.harming": "Lëng i dëmtimit",
  "item.minecraft.potion.effect.healing": "Lëng i shërimit",
  "item.minecraft.potion.effect.infested": "Lëng i infektimit",
  "item.minecraft.potion.effect.invisibility": "Lëng i padukshmërisë",
  "item.minecraft.potion.effect.leaping": "Lëng i kërcimit",
  "item.minecraft.potion.effect.levitation": "Lëng i levitacionit",
  "item.minecraft.potion.effect.luck": "Lëng i fatit",
  "item.minecraft.potion.effect.mundane": "Lëng i zakonshëm",
  "item.minecraft.potion.effect.night_vision": "Lëng i shikimit të natës",
  "item.minecraft.potion.effect.oozing": "Lëng i viskozitetit",
  "item.minecraft.potion.effect.poison": "Lëng i helmimit",
  "item.minecraft.potion.effect.regeneration": "Lëng i rigjenerimit",
  "item.minecraft.potion.effect.slow_falling": "Lëng i rënies së ngadaltë",
  "item.minecraft.potion.effect.slowness": "Lëng i ngadalësisë",
  "item.minecraft.potion.effect.strength": "Lëng i forcës",
  "item.minecraft.potion.effect.swiftness": "Lëng i shpejtësisë",
  "item.minecraft.potion.effect.thick": "Lëng i trashë",
  "item.minecraft.potion.effect.turtle_master": "Lëng i Breshkës Mjeshtër",
  "item.minecraft.potion.effect.water": "Shishe uji",
  "item.minecraft.potion.effect.water_breathing": "Lëng i frymëmarrjes nën ujë",
  "item.minecraft.potion.effect.weakness": "Lëng i dobësisë",
  "item.minecraft.potion.effect.weaving": "Lëng i gërshetimit",
  "item.minecraft.potion.effect.wind_charged": "Lëng i ngarkimit të erës",
  "item.minecraft.pottery_shard_archer": "Copë qeramike e shigjetarit",
  "item.minecraft.pottery_shard_arms_up": "Copë qeramike e trupit të njeriut",
  "item.minecraft.pottery_shard_prize": "Copë qeramike e xhevahirit",
  "item.minecraft.pottery_shard_skull": "Copë qeramike e kafkës",
  "item.minecraft.powder_snow_bucket": "Kovë me pluhur bore",
  "item.minecraft.prismarine_crystals": "Kristalet prismarineje",
  "item.minecraft.prismarine_shard": "Fragment prismarineje",
  "item.minecraft.prize_pottery_shard": "Copë qeramike e xhevahirit",
  "item.minecraft.prize_pottery_sherd": "Copë qeramike e xhevahirit",
  "item.minecraft.pufferfish": "Peshku i fryrë",
  "item.minecraft.pufferfish_bucket": "Peshku i fryrë në kovë",
  "item.minecraft.pufferfish_spawn_egg": "Veza pjellëse e peshkut fryrë",
  "item.minecraft.pumpkin_pie": "Tortë me kungull",
  "item.minecraft.pumpkin_seeds": "Fara kungulli",
  "item.minecraft.purple_bundle": "Çantë vjollcë",
  "item.minecraft.purple_dye": "Bojë vjollcë",
  "item.minecraft.purple_harness": "Rrip me mbulesë vjollcë",
  "item.minecraft.quartz": "Kuarc i Nether-it",
  "item.minecraft.rabbit": "Mish lepuri i papjekur",
  "item.minecraft.rabbit_foot": "Këmba e lepurit",
  "item.minecraft.rabbit_hide": "Lëkura e lepurit",
  "item.minecraft.rabbit_spawn_egg": "Veza pjellëse e lepurit",
  "item.minecraft.rabbit_stew": "Çomlek lepuri",
  "item.minecraft.raiser_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Zbukurim i armaturës së mbarështuesve",
  "item.minecraft.ravager_spawn_egg": "Veza pjellëse e shkatërruesit",
  "item.minecraft.raw_copper": "Bakër i papërpunuar",
  "item.minecraft.raw_gold": "Ar i papërpunuar",
  "item.minecraft.raw_iron": "Hekur i papërpunuar",
  "item.minecraft.recovery_compass": "Busull rimëkëmbjeje",
  "item.minecraft.red_bundle": "Çantë e kuqe",
  "item.minecraft.red_dye": "Bojë e kuqe",
  "item.minecraft.red_harness": "Rrip me mbulesë të kuqe",
  "item.minecraft.redstone": "Pluhur redstoni",
  "item.minecraft.resin_brick": "Tullë rrëshire",
  "item.minecraft.resin_clump": "Gungë rrëshire",
  "item.minecraft.rib_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Zbukurim i armaturës së brinjëve",
  "item.minecraft.rotten_flesh": "Mish i kalbur",
  "item.minecraft.saddle": "Shalë",
  "item.minecraft.salmon": "Salmon i papjekur",
  "item.minecraft.salmon_bucket": "Salmon në kovë",
  "item.minecraft.salmon_spawn_egg": "Veza pjellëse e salmonit",
  "item.minecraft.scrape_pottery_sherd": "Copë qeramike e sëpatës",
  "item.minecraft.scute": "Lëvozhgë",
  "item.minecraft.sentry_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Zbukurim i armaturës së rojeve",
  "item.minecraft.shaper_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Zbukurim i armaturës së krijuesve",
  "item.minecraft.sheaf_pottery_shard": "Copë qeramike e kallit misri",
  "item.minecraft.sheaf_pottery_sherd": "Copë qeramike e kallit misri",
  "item.minecraft.shears": "Gërshërë",
  "item.minecraft.sheep_spawn_egg": "Veza pjellëse e delës",
  "item.minecraft.shelter_pottery_shard": "Copë qeramike e strehës",
  "item.minecraft.shelter_pottery_sherd": "Copë qeramike e strehës",
  "item.minecraft.shield": "Mburojë",
  "item.minecraft.shield.black": "Mburojë e zezë",
  "item.minecraft.shield.blue": "Mburojë blu",
  "item.minecraft.shield.brown": "Mburojë e kaftë",
  "item.minecraft.shield.cyan": "Mburojë cian",
  "item.minecraft.shield.gray": "Mburojë gri",
  "item.minecraft.shield.green": "Mburojë e gjelbër",
  "item.minecraft.shield.light_blue": "Mburojë blu e lehtë",
  "item.minecraft.shield.light_gray": "Mburojë gri e lehtë",
  "item.minecraft.shield.lime": "Mburojë e gjelbër e çelët",
  "item.minecraft.shield.magenta": "Mburojë e purpurtë",
  "item.minecraft.shield.orange": "Mburojë e portokalltë",
  "item.minecraft.shield.pink": "Mburojë rozë",
  "item.minecraft.shield.purple": "Mburojë vjollcë",
  "item.minecraft.shield.red": "Mburojë e kuqe",
  "item.minecraft.shield.white": "Mburojë e bardhë",
  "item.minecraft.shield.yellow": "Mburojë e verdhë",
  "item.minecraft.shulker_shell": "Guaskë Shulker-it",
  "item.minecraft.shulker_spawn_egg": "Veza pjellëse e Shulker-it",
  "item.minecraft.sign": "Tabelë",
  "item.minecraft.silence_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Zbukurim i armaturës së heshtjes",
  "item.minecraft.silverfish_spawn_egg": "Veza pjellëse e peshkut të argjendtë",
  "item.minecraft.skeleton_horse_spawn_egg": "Veza pjellëse e kalit skelet",
  "item.minecraft.skeleton_spawn_egg": "Veza pjellëse e skeletit",
  "item.minecraft.skull_banner_pattern": "Modeli i banderolës",
  "item.minecraft.skull_banner_pattern.desc": "Kafkë",
  "item.minecraft.skull_banner_pattern.new": "Modeli kafkë për banderolën",
  "item.minecraft.skull_pottery_shard": "Copë qeramike e kafkës",
  "item.minecraft.skull_pottery_sherd": "Copë qeramike e kafkës",
  "item.minecraft.slime_ball": "Topi sllajmit",
  "item.minecraft.slime_spawn_egg": "Veza pjellëse e Sllajmit",
  "item.minecraft.smithing_template": "Modeli i farkëtimit",
  "item.minecraft.smithing_template.applies_to": "Vlen për:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Shtoni një shufër ose kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Parzmore",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Shto një pjesë parzmore",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Shufrat dhe kristalet",
  "item.minecraft.smithing_template.ingredients": "Përbërësit:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Shto një shufër Netheriti",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Pajisje me diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Shtoni një copë parzmore, armë ose mjet diamanti",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Shufër Netheriti",
  "item.minecraft.smithing_template.upgrade": "Përmirësim: ",
  "item.minecraft.sniffer_spawn_egg": "Veza pjellëse e nuhatësit",
  "item.minecraft.snort_pottery_shard": "Copë qeramike e nuhatësit",
  "item.minecraft.snort_pottery_sherd": "Copë qeramike e nuhatësit",
  "item.minecraft.snout_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Zbukurim i armaturës së feçkës",
  "item.minecraft.snow_golem_spawn_egg": "Veza pjellëse e golemit të borës",
  "item.minecraft.snowball": "Top bore",
  "item.minecraft.spectral_arrow": "Shigjetë spektrale",
  "item.minecraft.spider_eye": "Syri i merimangës",
  "item.minecraft.spider_spawn_egg": "Veza pjellëse e merimangës",
  "item.minecraft.spire_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Zbukurim i armaturës së kullave",
  "item.minecraft.splash_potion": "Lëng që hidhet",
  "item.minecraft.splash_potion.effect.awkward": "Lëng i çuditshëm që hidhet",
  "item.minecraft.splash_potion.effect.empty": "Lëng që hidhet jo i krijueshëm",
  "item.minecraft.splash_potion.effect.fire_resistance": "Lëng i rezistencës ndaj zjarrit që hidhet",
  "item.minecraft.splash_potion.effect.harming": "Lëng i dëmtimit që hidhet",
  "item.minecraft.splash_potion.effect.healing": "Lëng i shërimit që hidhet",
  "item.minecraft.splash_potion.effect.infested": "Lëng i infektimit që hidhet",
  "item.minecraft.splash_potion.effect.invisibility": "Lëng i padukshmërisë që hidhet",
  "item.minecraft.splash_potion.effect.leaping": "Lëng i kërcimit që hidhet",
  "item.minecraft.splash_potion.effect.levitation": "Lëng i levitacionit që hidhet",
  "item.minecraft.splash_potion.effect.luck": "Lëng i fatit që hidhet",
  "item.minecraft.splash_potion.effect.mundane": "Lëng i zakonshëm që hidhet",
  "item.minecraft.splash_potion.effect.night_vision": "Lëng i shikimit të natës që hidhet",
  "item.minecraft.splash_potion.effect.oozing": "Lëng i viskozitetit që hidhet",
  "item.minecraft.splash_potion.effect.poison": "Lëng i helmimit që hidhet",
  "item.minecraft.splash_potion.effect.regeneration": "Lëng i rigjenerimit që hidhet",
  "item.minecraft.splash_potion.effect.slow_falling": "Lëng i rënies së ngadaltë që hidhet",
  "item.minecraft.splash_potion.effect.slowness": "Lëng i ngadalësisë që hidhet",
  "item.minecraft.splash_potion.effect.strength": "Ilaç Hedhës i Forcës",
  "item.minecraft.splash_potion.effect.swiftness": "Lëng i shpejtësisë që hidhet",
  "item.minecraft.splash_potion.effect.thick": "Lëng i trashë që hidhet",
  "item.minecraft.splash_potion.effect.turtle_master": "Lëng i Breshkës Mjeshtër që hidhet",
  "item.minecraft.splash_potion.effect.water": "Shishe uji që hidhet",
  "item.minecraft.splash_potion.effect.water_breathing": "Lëng i frymëmarrjes nën ujë që hidhet",
  "item.minecraft.splash_potion.effect.weakness": "Lëng i dobësisë që hidhet",
  "item.minecraft.splash_potion.effect.weaving": "Lëng i gërshetimit që hidhet",
  "item.minecraft.splash_potion.effect.wind_charged": "Lëng i ngarkimit të erës që hidhet",
  "item.minecraft.spruce_boat": "Varkë bredhi",
  "item.minecraft.spruce_chest_boat": "Varkë magazinimi bredhi",
  "item.minecraft.spyglass": "Teleskop dore",
  "item.minecraft.squid_spawn_egg": "Veza pjellëse e oktapodit",
  "item.minecraft.stick": "Shkop",
  "item.minecraft.stone_axe": "Sëpatë guri",
  "item.minecraft.stone_hoe": "Kosë guri",
  "item.minecraft.stone_pickaxe": "Kazmë guri",
  "item.minecraft.stone_shovel": "Lopatë guri",
  "item.minecraft.stone_spear": "Shtiza guri",
  "item.minecraft.stone_sword": "Shpatë guri",
  "item.minecraft.stray_spawn_egg": "Veza pjellëse e arrakatit",
  "item.minecraft.strider_spawn_egg": "Veza pjellëse e këmbësorit",
  "item.minecraft.string": "Pe",
  "item.minecraft.sugar": "Sheqer",
  "item.minecraft.suspicious_stew": "Supë e dyshimtë",
  "item.minecraft.sweet_berries": "Manaferrat e ëmbla",
  "item.minecraft.tadpole_bucket": "Fulterëz në kovë",
  "item.minecraft.tadpole_spawn_egg": "Veza pjellëse e larvës së bretkosës",
  "item.minecraft.tide_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Zbukurim i armaturës së baticës",
  "item.minecraft.tipped_arrow": "Shigjetë me efekt",
  "item.minecraft.tipped_arrow.effect.awkward": "Shigjetë me lëng të çuditshëm",
  "item.minecraft.tipped_arrow.effect.empty": "Shigjetë me efekt jo i krijueshëm",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Shigjetë e rezistencës ndaj zjarrit",
  "item.minecraft.tipped_arrow.effect.harming": "Shigjetë e dëmtimit",
  "item.minecraft.tipped_arrow.effect.healing": "Shigjetë e shërimit",
  "item.minecraft.tipped_arrow.effect.infested": "Shigjetë e infektimit",
  "item.minecraft.tipped_arrow.effect.invisibility": "Shigjetë e padukshmërisë",
  "item.minecraft.tipped_arrow.effect.leaping": "Shigjetë e kërcimit",
  "item.minecraft.tipped_arrow.effect.levitation": "Shigjetë e levitacionit",
  "item.minecraft.tipped_arrow.effect.luck": "Shigjetë e fatit",
  "item.minecraft.tipped_arrow.effect.mundane": "Shigjetë e zakonshëm",
  "item.minecraft.tipped_arrow.effect.night_vision": "Shigjetë e shikimit të natës",
  "item.minecraft.tipped_arrow.effect.oozing": "Shigjetë e viskozitetit",
  "item.minecraft.tipped_arrow.effect.poison": "Shigjetë e helmit",
  "item.minecraft.tipped_arrow.effect.regeneration": "Shigjetë e rigjenerimit",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Shigjetë e rënies së ngadaltë",
  "item.minecraft.tipped_arrow.effect.slowness": "Shigjetë e ngadalësisë",
  "item.minecraft.tipped_arrow.effect.strength": "Shigjetë e forcës",
  "item.minecraft.tipped_arrow.effect.swiftness": "Shigjetë e shpejtësisë",
  "item.minecraft.tipped_arrow.effect.thick": "Shigjetë me lëng të trashë",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Shigjetë e Breshkës Mjeshtër",
  "item.minecraft.tipped_arrow.effect.water": "Shigjetë uji",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Shigjetë e frymëmarrjes nën ujë",
  "item.minecraft.tipped_arrow.effect.weakness": "Shigjetë e dobësisë",
  "item.minecraft.tipped_arrow.effect.weaving": "Shigjetë e gërshetimit",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Shigjetë e ngarkimit të erës",
  "item.minecraft.tnt_minecart": "Karrocë me TNT",
  "item.minecraft.torchflower_seeds": "Fara lulepishtari",
  "item.minecraft.totem_of_undying": "Totem i pavdekshmërisë",
  "item.minecraft.trader_llama_spawn_egg": "Veza pjellëse e lamës së tregtarit",
  "item.minecraft.trial_key": "Çelës sprove",
  "item.minecraft.trident": "Sfurk tredhëmbësh",
  "item.minecraft.tropical_fish": "Peshk tropikal",
  "item.minecraft.tropical_fish_bucket": "Peshk tropikal në kovë",
  "item.minecraft.tropical_fish_spawn_egg": "Veza pjellëse e peshkut tropikal",
  "item.minecraft.turtle_helmet": "Predha e breshkës",
  "item.minecraft.turtle_scute": "Lëvozhgë e breshkës",
  "item.minecraft.turtle_spawn_egg": "Veza pjellëse e breshkës",
  "item.minecraft.vex_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Zbukurim i armaturës së Veksit",
  "item.minecraft.vex_spawn_egg": "Veza pjellëse e Veksit",
  "item.minecraft.villager_spawn_egg": "Veza pjellëse e fshatarit",
  "item.minecraft.vindicator_spawn_egg": "Veza pjellëse e vindikatorit",
  "item.minecraft.wandering_trader_spawn_egg": "Veza pjellëse e tregtarit shëtitës",
  "item.minecraft.ward_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Zbukurim i armaturës së humnerës",
  "item.minecraft.warden_spawn_egg": "Veza pjellëse e Uardenit",
  "item.minecraft.warped_fungus_on_a_stick": "Kërpudhë e çuditshme në shkop",
  "item.minecraft.water_bucket": "Kovë me ujë",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Zbukurim i armaturës së udhërrëfyesit",
  "item.minecraft.wheat": "Grurë",
  "item.minecraft.wheat_seeds": "Farat e grurit",
  "item.minecraft.white_bundle": "Çantë e bardhë",
  "item.minecraft.white_dye": "Bojë e bardhë",
  "item.minecraft.white_harness": "Rrip me mbulesë të bardhë",
  "item.minecraft.wild_armor_trim_smithing_template": "Modeli i farkëtimit",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Zbukurim i armaturës së xhunglës",
  "item.minecraft.wind_charge": "Ngarkesë ere",
  "item.minecraft.witch_spawn_egg": "Veza pjellëse e shtrigës",
  "item.minecraft.wither_skeleton_spawn_egg": "Veza pjellëse e skeletit të Wither-it",
  "item.minecraft.wither_spawn_egg": "Veza pjellëse e Wither-it",
  "item.minecraft.wolf_armor": "Koracë e ujkut",
  "item.minecraft.wolf_spawn_egg": "Veza pjellëse e ujkut",
  "item.minecraft.wooden_axe": "Sëpatë druri",
  "item.minecraft.wooden_hoe": "Kosë druri",
  "item.minecraft.wooden_pickaxe": "Kazmë druri",
  "item.minecraft.wooden_shovel": "Lopatë druri",
  "item.minecraft.wooden_spear": "Shtiza druri",
  "item.minecraft.wooden_sword": "Shpatë druri",
  "item.minecraft.writable_book": "Libër dhe pendë",
  "item.minecraft.written_book": "Libër i shkruar",
  "item.minecraft.yellow_bundle": "Çantë e verdhë",
  "item.minecraft.yellow_dye": "Bojë e verdhë",
  "item.minecraft.yellow_harness": "Rrip me mbulesë të verdhë",
  "item.minecraft.zoglin_spawn_egg": "Veza pjellëse e Zoglin-it",
  "item.minecraft.zombie_horse_spawn_egg": "Veza pjellëse e kalit zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Veza pjellëse e nautilusit zombi",
  "item.minecraft.zombie_spawn_egg": "Veza pjellëse e zombit",
  "item.minecraft.zombie_villager_spawn_egg": "Veza pjellëse e fshatarit zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Veza pjellëse e Piglin-it të zombifikuar"
}
export const sq_al = items; 
